<template>
  <div class="Dashbord">
    <FloatingButtonMultiSingleTank :naslov="naslovIzvestaja" :tpwId="tank_phase_vineId"></FloatingButtonMultiSingleTank>
    <div class="vld-parent">
      <loading
        :active.sync="isLoading"
        :can-cancel="true"
        :is-full-page="fullPage"
        color="#018389"
        loader="dots"
      ></loading>
    </div>
    <ActionsNav></ActionsNav>
    <div class="Actions__Content">
      <v-container fluid style="padding-bottom: 10px">
        <Breadcrumbs />
        <!-- /.Breadcrumbs -->

        <section class="TankRoom">
          <h2>{{ this.items.tank.name }}</h2>

          <div class="TankHolder">
            <div
              :class="
                'Tank TankSingle ' +
                this.items.wine.wineLabel.wineType.enumLable
              "
              :id="this.items.tank.id"
              :key="this.items.tank.id"
              :data-tank-id="this.items.tank.id"
              :data-tank-type="this.items.tank.tankType.id"
              :data-tank-phase-vine-id="this.items.id"
              :data-tank-quantity="this.items.quantity"
              :data-tank-phase="this.items.phase.id"
              :data-wine-type="this.items.wine.wineLabel.wineType.id"
              :data-tank-name="this.items.tank.name"
              :data-wine-id="this.items.wine.id"
              :data-tank-phase-mark="this.items.phase.phaseMark"
              :data-tank-phase-bottling="String(this.items.phase.bottling)"
              :data-unit-of-measure="this.items.quantityUnitOfMeasure.mark"
              :data-unit-of-measure-id="this.items.quantityUnitOfMeasure.id"
              :data-vine-name="this.items.wine.wineLabel.name"
              :data-vine-year="this.items.wine.year"
              :data-tank-type-lable="this.items.tank.tankType.enumLable"
              :data-tank-edit="this.dozvoljena_izmena"
            >
              <div class="Tank__Bar">
                <!-- <span
                  class="counter"
                >{{ parseFloat(100 * (this.items.quantity/this.items.tank.capacity)).toFixed(2) }}%</span>-->
                <div class="bar">
                  <span
                    class="bar_Fill"
                    :style="
                      'height: ' +
                      (100 * this.items.quantity) / this.items.tank.capacity +
                      '%'
                    "
                  ></span>
                  <span class="bar_Bkg"></span>
                </div>
              </div>
              <!-- /.Tank__Bar -->

              <div class="Tank__Content">
                <p class="vineType">
                  {{ this.items.wine.wineLabel.name }}
                  {{ this.items.wine.year }}
                </p>

                <div class="Tank__Img">
                  <img
                    :src="
                      '../assets/iconsTanks/' +
                      this.items.tank.tankType.name +
                      '.svg'
                    "
                    alt="Tank Image"
                  />
                </div>
                <!-- /.Tank__Img -->

                <!-- <div class="Tank__Info">
                  <h4>{{ this.items.tank.name }}</h4>
                  <p class="amauntAvailable">
                    {{this.items.quantity}}l /
                    {{this.items.tank.capacity}}l
                  </p>
                </div>-->
                <div class="Tank__Info">
                  <h4 v-if="this.items.tank.tankType.name === 'barik'">
                    {{ this.items.tank.inventoryNumber }}
                  </h4>
                  <p class="amauntAvailable">
                    {{ this.items.quantity
                    }}{{ this.items.quantityUnitOfMeasure.mark }} /
                    {{ this.items.tank.capacity
                    }}{{ this.items.tank.unitOfMeasure.mark }}
                  </p>
                </div>
                <div class="row">
                  <div class="columnLeft">
                    {{
                      parseFloat(
                        100 * (this.items.quantity / this.items.tank.capacity)
                      ).toFixed(2)
                    }}%
                  </div>
                  <div class="columnRight">
                    {{ this.items.phase.phaseMark }}
                  </div>
                </div>

                <!-- /.Tank__Info -->
              </div>
              <div
                class="Tank__Info"
                v-if="
                  this.items.tank.piece !== null && this.items.tank.piece !== 0
                "
              >
                <div v-if="this.broj_barika !== this.items.tank.piece">
                  <span
                    class="value"
                    style="padding-left: 35px !important"
                    v-if="
                      this.items.tank.piece % 10 === 1 &&
                      this.items.tank.piece !== 11
                    "
                    ><a
                      v-on:click="otvoriModal_izabrani_tankovi"
                      style="margin-left: 10px"
                      title="Trenutno je punih "
                      >{{
                        this.broj_barika + "/" + this.items.tank.piece
                      }}
                      barik</a
                    >
                  </span>
                  <span class="value" style="padding-left: 35px" v-else
                    ><a
                      v-on:click="otvoriModal_izabrani_tankovi"
                      style="margin-left: 10px"
                      :title="title_broj_barika"
                      >{{
                        this.broj_barika + "/" + this.items.tank.piece
                      }}
                      barika</a
                    >
                  </span>
                </div>
                <div v-else>
                  <span
                    class="value"
                    style="padding-left: 35px !important"
                    v-if="
                      this.items.tank.piece % 10 === 1 &&
                      this.items.tank.piece !== 11
                    "
                    ><a
                      v-on:click="otvoriModal_izabrani_tankovi"
                      style="margin-left: 10px"
                      >{{ this.items.tank.piece }} barik</a
                    ></span
                  >
                  <span class="value" style="padding-left: 35px" v-else
                    ><a
                      v-on:click="otvoriModal_izabrani_tankovi"
                      style="margin-left: 10px"
                      >{{ this.items.tank.piece }} barika</a
                    >
                  </span>
                </div>
              </div>
              <div
                style="padding-top: 5px; text-align: center"
                v-if="this.items.tank.tankType.name === 'barik'"
              >
                <span style="width: 150px !important; text-align: center"
                  ><a v-on:click="otvoriDialog(null)"
                    >Istorija korišćenja</a
                  ></span
                >
              </div>
              <!-- /.Tank__Content -->
            </div>
            <!-- /.Tank -->

            <div class="TankDetails">
              <div
                class="TankDetails__Item"
                v-if="this.items.tank.tankType.name === 'barik'"
              >
                <span class="label" style="width: 120px">Datum nabavke:</span>
                <span class="value">{{ this.items.tank.bayingDate }}</span>
              </div>

              <div class="TankDetails__Item" v-if="prikazi_vina">
                <span class="maka">
                  <v-select
                    v-model="wine_to_select"
                    :items="wine_to_items"
                    item-value="id"
                    label="Vino"
                    persistent-hint
                    return-object
                  >
                    <template slot="selection" slot-scope="data"
                      >{{ data.item.wineLabel.name }}
                      {{ data.item.year }}</template
                    >
                    <template slot="item" slot-scope="data"
                      >{{ data.item.wineLabel.name }}
                      {{ data.item.year }}</template
                    >
                  </v-select>
                </span>
                <div>
                  <span class="kvaka">
                    <span style="padding-left: 15px">
                      <button @click="submit_wine">
                        <img
                          :src="`../assets/Ikone/icons8-checkmark-24_bela.png`"
                          alt="icon"
                          title="Snimi vino"
                        />
                      </button>
                    </span>

                    <span style="padding-left: 15px">
                      <button @click="close_wine">
                        <img
                          :src="`../assets/Ikone/icons8-delete-24_bela.png`"
                          alt="icon"
                          title="Odustani"
                        />
                      </button>
                    </span>
                  </span>
                </div>
              </div>
              <div class="TankDetails__Item" v-else>
                <span class="label">Vino:</span>
                <span class="value"
                  >{{ this.items.wine.wineLabel.name }}
                  {{ this.items.wine.year }}</span
                >

                <span style="padding-left: 15px">
                  <button
                    @click="submit_parameter5"
                    v-if="this.dozvoljena_izmena !== 0"
                  >
                    <img
                      :src="`../assets/Ikone/icons8-edit-24_bela.png`"
                      alt="icon"
                      title="Izmena vina"
                    />
                  </button>
                </span>
              </div>

              <div class="TankDetails__Item" v-if="prikazi_faze">
                <span class="maka">
                  <v-select
                    v-model="phase_to_select"
                    :items="phase_to_items_pom"
                    item-text="name"
                    item-value="id"
                    label="Faza"
                    persistent-hint
                    return-object
                  >
                  </v-select>
                </span>
                <div>
                  <span class="kvaka">
                    <span style="padding-left: 10px">
                      <button @click="submit" slot="activator">
                        <img
                          :src="`../assets/Ikone/icons8-checkmark-24_bela.png`"
                          alt="icon"
                          title="Snimi fazu"
                        />
                      </button>
                    </span>

                    <span style="padding-left: 10px">
                      <button @click="close">
                        <img
                          :src="`../assets/Ikone/icons8-delete-24_bela.png`"
                          alt="icon"
                          title="Odustani"
                        />
                      </button>
                    </span>
                  </span>
                </div>
              </div>
              <div class="TankDetails__Item" v-else>
                <span class="label">Faza:</span>
                <span class="value">{{ this.items.phase.name }}</span>
                <span style="padding-left: 10px">
                  <button
                    @click="submit_parameter4"
                    v-if="this.dozvoljena_izmena !== 0"
                  >
                    <img
                      :src="`../assets/Ikone/icons8-edit-24_bela.png`"
                      alt="icon"
                      title="Izmena faze"
                    />
                  </button>
                </span>
              </div>

              <div class="TankDetails__Item">
                <span class="label" style="width: 170px"
                  >Temperatura (Ž/T):</span
                >
                <span class="value">{{
                  this.zeljena_temperatura +
                  " °C / " +
                  this.trenutna_temperatura +
                  " °C"
                }}</span>
                <span style="padding-left: 10px">
                  <button
                    @click="submit_parameter"
                    v-if="this.dozvoljena_izmena !== 0"
                  >
                    <img
                      :src="`../assets/Ikone/icons8-edit-24_bela.png`"
                      alt="icon"
                      title="Unos i izmena željene temperature"
                    />
                  </button>
                </span>
              </div>
              <!-- /.TankDetails__Item -->

              <div class="TankDetails__Item">
                <span class="label" style="width: 170px"
                  >Parametri fermentacije:</span
                >
                <span class="value">{{
                  this.trenutno_secera +
                  " °Oe / " +
                  this.poslednja_temperatura +
                  " °C"
                }}</span>
                <span style="padding-left: 10px">
                  <button
                    @click="submit_parameter2"
                    v-if="this.dozvoljena_izmena !== 0"
                  >
                    <img
                      :src="`../assets/Ikone/icons8-edit-24_bela.png`"
                      alt="icon"
                      title="Unos i izmena parametara fermentacije"
                    />
                  </button>
                </span>
              </div>

              <div class="TankDetails__Item">
                <span class="label" style="width: 170px"
                  >Grafik fermentacije:</span
                >
                <button
                  :key="this.items.id"
                  :data-index="this.items.id"
                  @click="submit_parameterGrafic(items.id)"
                >
                  <img
                    :src="`../assets/Ikone/icons8-increase-24_bela.png`"
                    alt="icon"
                    :title="items.tank.name"
                  />
                </button>
                <a
                  v-for="grafik in items_grafici"
                  :key="grafik.tankPhaseWineId"
                  :data-index="grafik.tankPhaseWineId"
                  v-on:click="submit_parameterGrafic(grafik.tankPhaseWineId)"
                  style="margin-left: 10px"
                  >{{ grafik.tankName }}</a
                >
              </div>

              <div class="TankDetails__Item">
                <span class="label">Komentari:</span>
                <span
                  class="value"
                  v-if="this.poslednji_komentar === undefined"
                ></span>
                <span
                  class="value"
                  v-else-if="this.poslednji_komentar.length <= 25"
                  >{{ this.poslednji_komentar }}</span
                >
                <span class="value" :title="this.poslednji_komentar" v-else
                  >{{ this.poslednji_komentar.substring(0, 24) }}...</span
                >

                <span style="padding-left: 10px">
                  <button
                    @click="submit_parameter3"
                    v-if="this.dozvoljena_izmena !== 0"
                  >
                    <img
                      :src="`../assets/Ikone/icons8-edit-24_bela.png`"
                      alt="icon"
                      title="Unos i izmena komentara"
                    />
                  </button>
                </span>
              </div>

              <div class="TankDetails__Item" v-if="administrator">
                <span class="label" style="width: 170px"
                  >Trošak proizvodnje:</span
                >
                <span v-if="this.cena !== ''" class="value">{{
                  this.cena
                }}</span>
              </div>
            </div>
            <!-- /.TankDetails -->

            <div class="TankDetails" ref="chartdiv"></div>
            <!-- /.TankDetails -->
          </div>
          <!-- /.FlexHolder -->
        </section>
        <!-- /.TankRoom -->
      </v-container>

      <v-container fluid style="padding-top: 10px; padding-bottom: 10px">
        <v-app id="inspire" class="TabClass">
          <!-- Promene stanja -->
          <v-layout
            row
            wrap
            style="max-height: 60px !important; padding-top: 0px !important"
          >
            <v-flex xs2 pa-2> </v-flex>
            <v-flex xs8 pa-2>
              <v-tabs fixed-tabs v-model="selectedTab">
                <v-tab
                  v-on:click.native="doSomething(1)"
                  style="padding-left: 20px; padding-right: 20px"
                  >Promene</v-tab
                >
                <v-tab
                  v-on:click.native="doSomething(2)"
                  style="padding-left: 20px; padding-right: 20px"
                  >Ulazi</v-tab
                >
                <v-tab
                  v-on:click.native="doSomething(3)"
                  style="padding-left: 20px; padding-right: 20px"
                  >Izlazi</v-tab
                >
                <v-tab
                  v-on:click.native="doSomething(4)"
                  style="padding-left: 20px; padding-right: 20px"
                  >Ulazi grožđa</v-tab
                >
              </v-tabs>
            </v-flex>
            <v-flex xs1 pa-2></v-flex>
            <v-flex
              xs1
              pa-2
              style="
                padding-top: 18px !important;
                padding-right: 18px !important;
              "
            >
              <MultiButtonSingleTank
                :items="items"
                :tip_tanka="tip_tanka"
                :selectedTabDodaci="selectedTabDodaci"
                :items_dodaci="items_dodaci"
                :selectedTabMerenja="selectedTabMerenja"
                :items_merenja="items_merenja"
                :items_promene="items_inputoutput"
                :tank_phase_vineId="tank_phase_vineId"
                :selectedTab="selectedTab"
              ></MultiButtonSingleTank>
            </v-flex>
          </v-layout>

          <template v-if="selectedTab !== 3">
            <v-data-table
              :headers="headers_inputoutput"
              :items="items_inputoutput"
              class="TankTable"
              hide-actions
              :pagination.sync="pagination"
            >
              <template slot="headers" slot-scope="props">
                <tr>
                  <th
                    style="
                      text-align: center;
                      padding-left: 5px;
                      padding-right: 5px;
                    "
                    v-for="header in props.headers"
                    :key="header.text"
                    :class="[
                      'column sortable',
                      pagination.descending ? 'desc' : 'asc',
                      header.value === pagination.sortBy ? 'active' : '',
                      header.align === 'left'
                        ? 'text-xs-left'
                        : 'text-xs-center',
                    ]"
                    @click="changeSort(header.value)"
                  >
                    <v-icon small v-if="header.sortable !== false"
                      >arrow_upward</v-icon
                    >
                    {{ header.text }}
                  </th>
                </tr>
              </template>

              <template slot="items" slot-scope="props">
                <td
                  style="
                    text-align: center;
                    padding-left: 5px;
                    padding-right: 5px;
                  "
                >
                  {{ props.item.no }}
                </td>
                <td
                  style="
                    text-align: center;
                    padding-left: 5px;
                    padding-right: 5px;
                  "
                >
                  {{ formatDateTime(props.item.date) }}
                </td>
                <td
                  style="
                    text-align: center;
                    padding-left: 5px;
                    padding-right: 5px;
                  "
                >
                  {{ props.item.phaseAtMoment }}
                </td>
                <td
                  style="
                    text-align: center;
                    padding-left: 5px;
                    padding-right: 5px;
                  "
                >
                  {{ props.item.wineAtMoment }}
                </td>
                <td
                  style="
                    text-align: center;
                    padding-left: 5px;
                    padding-right: 5px;
                  "
                >
                  {{
                    prevediOperacijeLok(
                      props.item.operation,
                      props.item.pressingFraction
                    )
                  }}
                </td>
                <template v-if="selectedTab === 0">
                  <td
                    style="
                      text-align: center;
                      padding-left: 5px;
                      padding-right: 5px;
                    "
                  >
                    <a
                      v-if="
                        props.item.active &&
                        props.item.tankFromBatchInOperations.length === 0
                      "
                      v-on:click="
                        routerLinkToDetails(
                          props.item.previousTankPhaseWineId,
                          props.item.tankId,
                          props.item.active
                        )
                      "
                      >{{
                        formatTank_IZ(
                          props.item.changeOfState,
                          props.item.tankName,
                          props.item
                        )
                      }}</a
                    >
                    <a
                      style="color: grey"
                      v-else-if="
                        props.item.tankFromBatchInOperations.length === 0
                      "
                      v-on:click="
                        routerLinkToDetails(
                          props.item.previousTankPhaseWineId,
                          props.item.tankId,
                          props.item.active
                        )
                      "
                      >{{
                        formatTank_IZ(
                          props.item.changeOfState,
                          props.item.tankName,
                          props.item
                        )
                      }}</a
                    >
                    <a
                      v-else
                      v-on:click="
                        routerLinkToDetails(
                          props.item.previousTankPhaseWineId,
                          props.item.tankId,
                          props.item.active
                        )
                      "
                      >{{
                        formatTank_IZ(
                          props.item.changeOfState,
                          props.item.tankName,
                          props.item
                        )
                      }}</a
                    >
                    <template
                      v-if="props.item.tankFromBatchInOperations !== null"
                    >
                      <v-menu
                        open-on-hover
                        top
                        offset-x
                        nudge-right="20"
                        close-delay="100"
                        v-if="props.item.tankFromBatchInOperations.length > 0"
                      >
                        <template v-slot:activator="{}">
                          <v-icon
                            slot="activator"
                            small
                            class="ml-2"
                            color="teal"
                          >
                            info
                          </v-icon>
                          <span>
                            <v-container style="background-color: white">
                              <div class="DataTable">
                                <v-layout>
                                  <v-flex
                                    xs11
                                    pa-2
                                    style="font-size: 20px !important"
                                  >
                                    Spisak barika
                                  </v-flex>
                                </v-layout>

                                <v-layout column>
                                  <v-flex style="overflow: auto">
                                    <v-data-table
                                      :headers="
                                        headers_modal_izabrani_tankovi_2
                                      "
                                      :items="
                                        props.item.tankFromBatchInOperations
                                      "
                                      hide-actions
                                      class="elevation-1"
                                      show-select
                                      dense
                                      select-all
                                      :pagination.sync="pagination"
                                    >
                                      <template
                                        slot="headers"
                                        slot-scope="props_modal"
                                      >
                                        <tr>
                                          <th
                                            style="
                                              text-align: center;
                                              padding: 5px;
                                            "
                                            v-for="header in props_modal.headers"
                                            :key="header.text"
                                          >
                                            {{ header.text }}
                                          </th>
                                        </tr>
                                      </template>
                                      <template
                                        slot="items"
                                        slot-scope="props_modal"
                                      >
                                        <tr>
                                          <td
                                            style="
                                              text-align: center;
                                              padding-left: 5px;
                                              padding-right: 5px;
                                            "
                                            v-if="
                                              props_modal.item.tank
                                                .batchPrefix !== null &&
                                              props_modal.item.tank
                                                .batchPrefix !== ''
                                            "
                                          >
                                            {{
                                              props_modal.item.tank.batchPrefix
                                            }}
                                          </td>
                                          <td
                                            style="
                                              text-align: center;
                                              padding-left: 5px;
                                              padding-right: 5px;
                                            "
                                            v-else
                                          >
                                            -
                                          </td>
                                          <td
                                            style="
                                              text-align: center;
                                              padding-left: 5px;
                                              padding-right: 5px;
                                            "
                                          >
                                            {{ props_modal.item.tank.name }}
                                          </td>
                                          <td
                                            style="
                                              text-align: center;
                                              padding-left: 5px;
                                              padding-right: 5px;
                                            "
                                          >
                                            {{
                                              props_modal.item.tank
                                                .inventoryNumber
                                            }}
                                          </td>
                                          <td
                                            style="
                                              text-align: center;
                                              padding-left: 5px;
                                              padding-right: 5px;
                                            "
                                          >
                                            {{
                                              props_modal.item.tank.capacity +
                                              " " +
                                              props_modal.item.tank
                                                .unitOfMeasure.mark
                                            }}
                                          </td>
                                        </tr>
                                      </template>
                                    </v-data-table>
                                  </v-flex>
                                </v-layout>
                              </div>
                            </v-container>
                          </span>
                        </template>
                      </v-menu>
                    </template>
                  </td>
                  <td
                    style="
                      text-align: center;
                      padding-left: 5px;
                      padding-right: 5px;
                    "
                  >
                    <a
                      v-if="props.item.active"
                      v-on:click="
                        routerLinkToDetails(
                          props.item.tankPhaseWineId,
                          props.item.tankId,
                          props.item.active
                        )
                      "
                      >{{
                        formatTank_U(
                          props.item.changeOfState,
                          props.item.tankName
                        )
                      }}</a
                    >
                    <a
                      v-else
                      style="color: grey"
                      v-on:click="
                        routerLinkToDetails(
                          props.item.tankPhaseWineId,
                          props.item.tankId,
                          props.item.active
                        )
                      "
                      >{{
                        formatTank_U(
                          props.item.changeOfState,
                          props.item.tankName
                        )
                      }}</a
                    >
                  </td>
                </template>
                <template v-else-if="selectedTab == 2">
                  <td
                    style="
                      text-align: center;
                      padding-left: 5px;
                      padding-right: 5px;
                    "
                  >
                    <a
                      v-if="props.item.active"
                      v-on:click="
                        routerLinkToDetails(
                          props.item.tankPhaseWineId,
                          props.item.tankId,
                          props.item.active
                        )
                      "
                      >{{
                        formatTank_U(
                          props.item.changeOfState,
                          props.item.tankName
                        )
                      }}</a
                    >
                    <a
                      v-else
                      style="color: grey"
                      v-on:click="
                        routerLinkToDetails(
                          props.item.tankPhaseWineId,
                          props.item.tankId,
                          props.item.active
                        )
                      "
                      >{{
                        formatTank_U(
                          props.item.changeOfState,
                          props.item.tankName
                        )
                      }}</a
                    >
                  </td>
                </template>
                <template v-else>
                  <td
                    style="
                      text-align: center;
                      padding-left: 5px;
                      padding-right: 5px;
                    "
                  >
                    <a
                      v-if="props.item.active"
                      v-on:click="
                        routerLinkToDetails(
                          props.item.previousTankPhaseWineId,
                          props.item.tankId,
                          props.item.active
                        )
                      "
                      >{{
                        formatTank_IZ(
                          props.item.changeOfState,
                          props.item.tankName,
                          null
                        )
                      }}</a
                    >
                    <a
                      v-else
                      style="color: grey"
                      v-on:click="
                        routerLinkToDetails(
                          props.item.previousTankPhaseWineId,
                          props.item.tankId,
                          props.item.active
                        )
                      "
                      >{{
                        formatTank_IZ(
                          props.item.changeOfState,
                          props.item.tankName,
                          null
                        )
                      }}</a
                    >
                  </td>
                </template>

                <td
                  style="
                    text-align: center;
                    padding-left: 5px;
                    padding-right: 5px;
                  "
                >
                  {{
                    props.item.quantity === null
                      ? ""
                      : props.item.quantity + " " + props.item.quantityMark
                  }}
                </td>
                <td
                  style="
                    text-align: center;
                    padding-left: 5px;
                    padding-right: 5px;
                  "
                >
                  {{
                    props.item.sediment === null
                      ? ""
                      : props.item.sediment + " " + props.item.sedimentMark
                  }}
                </td>
                <td
                  style="
                    text-align: center;
                    padding-left: 5px;
                    padding-right: 5px;
                  "
                >
                  {{
                    props.item.outage === null
                      ? ""
                      : props.item.outage + " " + props.item.outageMark
                  }}
                </td>
                <!-- <td>{{ props.item.unitOfMeasure.name }}</td> -->
                <td>{{ props.item.description }}</td>
              </template>
              <!-- <template v-else>
                
              </template> -->

              <!-- </template> -->
            </v-data-table>
          </template>
          <template v-else>
            <v-data-table
              :headers="headers_inputoutput"
              :items="items_inputoutput"
              class="TankTable"
              hide-actions
              :pagination.sync="pagination"
            >
              <template slot="headers" slot-scope="props">
                <tr>
                  <th
                    style="
                      text-align: center;
                      padding-left: 5px;
                      padding-right: 5px;
                    "
                    v-for="header in props.headers"
                    :key="header.text"
                    :class="[
                      'column sortable',
                      pagination.descending ? 'desc' : 'asc',
                      header.value === pagination.sortBy ? 'active' : '',
                      header.align === 'left'
                        ? 'text-xs-left'
                        : 'text-xs-center',
                    ]"
                    @click="changeSort(header.value)"
                  >
                    <v-icon small v-if="header.sortable !== false"
                      >arrow_upward</v-icon
                    >
                    {{ header.text }}
                  </th>
                </tr>
              </template>

              <template slot="items" slot-scope="props">
                <td
                  style="
                    text-align: center;
                    padding-left: 5px;
                    padding-right: 5px;
                  "
                >
                  {{
                    items_inputoutput
                      .map(function (x) {
                        return x.id;
                      })
                      .indexOf(props.item.id) + 1
                  }}
                </td>
                <td
                  style="
                    text-align: center;
                    padding-left: 5px;
                    padding-right: 5px;
                  "
                >
                  {{ props.item.tankName }}
                </td>
                <td
                  style="
                    text-align: center;
                    padding-left: 5px;
                    padding-right: 5px;
                  "
                >
                  {{ props.item.grapeVariety }}
                </td>
                <td
                  style="
                    text-align: center;
                    padding-left: 5px;
                    padding-right: 5px;
                  "
                >
                  {{ props.item.vineyard }}
                </td>
                <td
                  style="
                    text-align: center;
                    padding-left: 5px;
                    padding-right: 5px;
                  "
                >
                  {{ formatDate(props.item.harvestDate) }}
                </td>
                <td
                  style="
                    text-align: center;
                    padding-left: 5px;
                    padding-right: 5px;
                  "
                >
                  {{ formatDateTime(props.item.entryDate) }}
                </td>
                <td
                  style="
                    text-align: center;
                    padding-left: 5px;
                    padding-right: 5px;
                  "
                >
                  {{ props.item.relativePart }}
                </td>
                <td
                  style="
                    text-align: center;
                    padding-left: 5px;
                    padding-right: 5px;
                  "
                >
                  {{ props.item.grapeQuantity }}
                </td>
                <td
                  style="
                    text-align: center;
                    padding-left: 5px;
                    padding-right: 5px;
                  "
                >
                  {{ props.item.stumQuantity }}
                </td>
                <td
                  style="
                    text-align: center;
                    padding-left: 5px;
                    padding-right: 5px;
                  "
                  v-if="props.item.grapePrice !== null"
                >
                  {{ props.item.grapePrice }} RSD
                </td>
                <td
                  style="
                    text-align: center;
                    padding-left: 5px;
                    padding-right: 5px;
                  "
                  v-else
                >
                  -
                </td>
                <td
                  style="
                    text-align: center;
                    padding-left: 5px;
                    padding-right: 5px;
                  "
                >
                  {{ props.item.grapeTemperature }}
                </td>
                <td
                  style="
                    text-align: center;
                    padding-left: 5px;
                    padding-right: 5px;
                  "
                >
                  {{ props.item.maceration }}
                </td>
                <td>{{ props.item.description }}</td>
              </template>
              <!-- <template v-else>
                
              </template> -->

              <!-- </template> -->
            </v-data-table>
          </template>

          <div>
            <v-layout
              row
              wrap
              style="
                max-height: 60px !important;
                padding-top: 0px !important;
                margin-top: 30px !important;
              "
            >
              <v-flex xs2 pa-2>
                <v-text-field
                  v-model="search"
                  append-icon="search"
                  label="Pretraga"
                  xs5
                  hide-details
                  style="margin-top: 10px !important"
                ></v-text-field>
              </v-flex>
              <v-flex xs8 pa-2>
                <v-tabs fixed-tabs v-model="selectedTabDodaci">
                  <v-tab
                    v-on:click.native="getAllDodaci(true)"
                    style="padding-left: 20px; padding-right: 20px"
                    >Dodavanja</v-tab
                  >
                  <v-tab
                    v-on:click.native="getAllDodaci(false)"
                    style="padding-left: 20px; padding-right: 20px"
                    >Prethodna dodavanja</v-tab
                  >
                </v-tabs>
              </v-flex>
              <v-flex xs1 pa-2></v-flex>
              <v-flex xs1 pa-2 style="text-align: right"
                ><v-btn @click="stampaj" fab small
                  ><img
                    src="../assets/menuIcons/ico-print.png"
                    title="Štampa dodataka" /></v-btn
              ></v-flex>
            </v-layout>

            <v-layout column>
              <v-flex style="overflow: auto">
                <v-data-table
                  :headers="headers_dodaci"
                  :items="items_dodaci"
                  class="TankTable"
                  hide-actions
                  :pagination.sync="paginationDodaci"
                  :search="search"
                >
                  <template slot="headers" slot-scope="props">
                    <tr>
                      <th
                        v-for="header in props.headers"
                        :key="header.text"
                        :class="[
                          'column sortable',
                          paginationDodaci.descending ? 'desc' : 'asc',
                          header.value === paginationDodaci.sortBy
                            ? 'active'
                            : '',
                          header.align === 'left'
                            ? 'text-xs-left'
                            : 'text-xs-center',
                        ]"
                        @click="changeSortDodaci(header.value)"
                      >
                        <v-icon small v-if="header.sortable !== false"
                          >arrow_upward</v-icon
                        >
                        {{ header.text }}
                      </th>
                    </tr>
                  </template>
                  <template slot="items" slot-scope="props">
                    <td>
                      {{
                        items_dodaci
                          .map(function (x) {
                            return x.id;
                          })
                          .indexOf(props.item.id) + 1
                      }}
                    </td>
                    <td style="padding-left: 5px; padding-right: 5px">
                      {{ formatDateTime(props.item.date) }}
                    </td>
                    <td
                      style="text-align: center"
                      v-if="props.item.microOrMacro !== null"
                    >
                      {{
                        proracunajTrajanje(
                          props.item.date,
                          props.item.oxygenationEndDate
                        )
                      }}
                    </td>
                    <td v-else></td>

                    <template v-if="tip_tanka === 15">
                      <td
                        v-if="props.item.tankFromBatchInOperations.length > 1"
                        style="text-align: center"
                      >
                        {{ formatImena(props.item) }}
                        <v-menu
                          open-on-hover
                          top
                          offset-x
                          nudge-right="20"
                          close-delay="100"
                        >
                          <template v-slot:activator="{}">
                            <v-icon
                              slot="activator"
                              small
                              class="ml-2"
                              color="teal"
                            >
                              info
                            </v-icon>
                            <span>
                              <v-container
                                scrollable
                                style="
                                  max-height: 750px !important;
                                  background-color: white;
                                "
                              >
                                <div class="DataTable">
                                  <v-layout>
                                    <v-flex
                                      xs11
                                      pa-2
                                      style="font-size: 20px !important"
                                    >
                                      Spisak barika
                                    </v-flex>
                                  </v-layout>

                                  <v-layout column>
                                    <v-flex
                                      style="
                                        overflow: auto;
                                        max-height: 550px !important;
                                      "
                                    >
                                      <v-data-table
                                        :headers="headers_modal_izabrani_barici"
                                        :items="
                                          props.item.tankFromBatchInOperations
                                        "
                                        hide-actions
                                        class="elevation-1"
                                        show-select
                                        dense
                                        select-all
                                        :pagination.sync="pagination"
                                      >
                                        <template
                                          slot="headers"
                                          slot-scope="props_modal"
                                        >
                                          <tr>
                                            <th
                                              style="
                                                text-align: center;
                                                padding: 5px;
                                              "
                                              v-for="header in props_modal.headers"
                                              :key="header.text"
                                            >
                                              {{ header.text }}
                                            </th>
                                          </tr>
                                        </template>
                                        <template
                                          slot="items"
                                          slot-scope="props_modal"
                                        >
                                          <tr>
                                            <td
                                              style="
                                                text-align: center;
                                                padding-left: 5px;
                                                padding-right: 5px;
                                              "
                                              v-if="
                                                props_modal.item.tank
                                                  .batchPrefix !== null &&
                                                props_modal.item.tank
                                                  .batchPrefix !== ''
                                              "
                                            >
                                              {{
                                                props_modal.item.tank
                                                  .batchPrefix
                                              }}
                                            </td>
                                            <td
                                              style="
                                                text-align: center;
                                                padding-left: 5px;
                                                padding-right: 5px;
                                              "
                                              v-else
                                            >
                                              -
                                            </td>
                                            <td
                                              style="
                                                text-align: center;
                                                padding-left: 5px;
                                                padding-right: 5px;
                                              "
                                            >
                                              {{ props_modal.item.tank.name }}
                                            </td>
                                            <td
                                              style="
                                                text-align: center;
                                                padding-left: 5px;
                                                padding-right: 5px;
                                              "
                                            >
                                              {{
                                                props_modal.item.tank
                                                  .inventoryNumber
                                              }}
                                            </td>
                                            <td
                                              style="
                                                text-align: center;
                                                padding-left: 5px;
                                                padding-right: 5px;
                                              "
                                            >
                                              {{
                                                props_modal.item.tank.capacity +
                                                " " +
                                                props_modal.item.tank
                                                  .unitOfMeasure.mark
                                              }}
                                            </td>
                                          </tr>
                                        </template>
                                      </v-data-table>
                                    </v-flex>
                                  </v-layout>
                                </div>
                              </v-container>
                            </span>
                          </template>
                        </v-menu>
                      </td>
                      <td
                        class="justify-center align-content-center pa-2 text-xs-center"
                        style="padding-right: 0px !important"
                        v-else-if="
                          props.item.tankFromBatchInOperations.length === 1
                        "
                      >
                        <template
                          v-if="
                            props.item.tankFromBatchInOperations[0].tank
                              .inventoryNumber !== null &&
                            props.item.tankFromBatchInOperations[0].tank
                              .inventoryNumber !== ''
                          "
                        >
                          {{
                            props.item.tankFromBatchInOperations[0].tank
                              .batchPrefix +
                            " | " +
                            props.item.tankFromBatchInOperations[0].tank.name +
                            " | " +
                            props.item.tankFromBatchInOperations[0].tank
                              .inventoryNumber
                          }}
                        </template>
                        <template v-else>
                          {{
                            props.item.tankFromBatchInOperations[0].tank
                              .batchPrefix +
                            " | " +
                            props.item.tankFromBatchInOperations[0].tank.name
                          }}
                        </template>
                      </td>
                      <td
                        class="justify-center align-content-center pa-2 text-xs-center"
                        style="padding-right: 2% !important"
                        v-else
                      >
                        {{ "Svi barici" }}
                      </td>
                    </template>
                    <td
                      style="
                        text-align: center;
                        padding-left: 5px;
                        padding-right: 5px;
                      "
                    >
                      {{
                        props.item.name +
                        (props.item.microOrMacro !== null
                          ? " (" + props.item.microOrMacro + " oksigenacija)"
                          : "")
                      }}
                    </td>
                    <td
                      style="
                        text-align: center;
                        padding-left: 5px;
                        padding-right: 5px;
                      "
                    >
                      {{
                        props.item.quantity +
                        " " +
                        props.item.unitOfMeasure.replace("psc", "kom")
                      }}
                    </td>
                    <!-- <td style="text-align:center; padding-left:5px; padding-right:5px;">{{ props.item.tankName }}</td> -->
                    <td
                      style="
                        text-align: center;
                        padding-left: 5px;
                        padding-right: 5px;
                      "
                    >
                      <a
                        v-if="props.item.active"
                        v-on:click="
                          routerLinkToDetails(
                            props.item.tankPhaseWineId,
                            props.item.tankId,
                            props.item.active
                          )
                        "
                        >{{ props.item.tankName }}</a
                      >
                      <a
                        v-else
                        style="color: grey"
                        v-on:click="
                          routerLinkToDetails(
                            props.item.tankPhaseWineId,
                            props.item.tankId,
                            props.item.active
                          )
                        "
                        >{{ props.item.tankName }}</a
                      >
                    </td>
                    <td
                      style="
                        text-align: center;
                        padding-left: 5px;
                        padding-right: 5px;
                      "
                    >
                      {{ props.item.phaseAtMoment }}
                    </td>
                    <td>{{ props.item.wineAtMoment }}</td>
                    <td
                      style="
                        text-align: center;
                        padding-left: 5px;
                        padding-right: 5px;
                      "
                    >
                      {{
                        props.item.wineQuantityAtMoment +
                        " " +
                        props.item.wineQuantityAtMomentUnitOfMeasure
                      }}
                    </td>
                    <td>{{ props.item.description }}</td>
                  </template>
                </v-data-table>
              </v-flex>
            </v-layout>

            <v-layout
              row
              wrap
              style="
                max-height: 60px !important;
                padding-top: 0px !important;
                margin-top: 30px !important;
              "
            >
              <v-flex xs2 pa-2>
                <v-text-field
                  v-model="search_merenja"
                  append-icon="search"
                  label="Pretraga"
                  xs5
                  hide-details
                  style="margin-top: 10px !important"
                ></v-text-field>
              </v-flex>
              <v-flex xs8 pa-2>
                <v-tabs fixed-tabs v-model="selectedTabMerenja">
                  <v-tab
                    v-on:click.native="getAllMerenja(true)"
                    style="padding-left: 20px; padding-right: 20px"
                    >Merenja</v-tab
                  >
                  <v-tab
                    v-on:click.native="getAllMerenja(false)"
                    style="padding-left: 20px; padding-right: 20px"
                    >Prethodna merenja</v-tab
                  >
                </v-tabs>
              </v-flex>
              <v-flex xs1 pa-2></v-flex>
              <v-flex xs1 pa-2 style="text-align: right"
                ><v-btn @click="stampajMerenja" fab small
                  ><img
                    src="../assets/menuIcons/ico-print.png"
                    title="Štampa merenja" /></v-btn
              ></v-flex>
            </v-layout>

            <v-layout column>
              <v-flex style="overflow: auto">
                <v-data-table
                  :headers="headers_merenja"
                  :items="items_merenja"
                  class="TankTable"
                  hide-actions
                  :pagination.sync="paginationMerenja"
                  :search="search_merenja"
                >
                  <template slot="headers" slot-scope="props">
                    <tr>
                      <th
                        v-for="header in props.headers"
                        :key="header.text"
                        :class="[
                          'column sortable',
                          paginationMerenja.descending ? 'desc' : 'asc',
                          header.value === paginationMerenja.sortBy
                            ? 'active'
                            : '',
                          header.align === 'left'
                            ? 'text-xs-left'
                            : 'text-xs-center',
                        ]"
                        @click="changeSortMerenja(header.value)"
                      >
                        <v-icon small v-if="header.sortable !== false"
                          >arrow_upward</v-icon
                        >
                        {{ header.text }}
                      </th>
                    </tr>
                  </template>

                  <template slot="items" slot-scope="props">
                    <td>
                      {{
                        items_merenja
                          .map(function (x) {
                            return x.id;
                          })
                          .indexOf(props.item.id) + 1
                      }}
                    </td>
                    <!-- <td>{{ props.item.id }}</td> -->
                    <td style="padding-left: 5px; padding-right: 5px">
                      {{ formatDateTime(props.item.date) }}
                    </td>
                    <template v-if="tip_tanka === 15">
                      <td
                        v-if="props.item.tankFromBatchInOperations.length > 1"
                        style="text-align: center"
                      >
                        {{ formatImena(props.item) }}
                        <v-menu
                          open-on-hover
                          top
                          offset-x
                          nudge-right="20"
                          close-delay="100"
                        >
                          <template v-slot:activator="{}">
                            <v-icon
                              slot="activator"
                              small
                              class="ml-2"
                              color="teal"
                            >
                              info
                            </v-icon>
                            <span>
                              <v-container
                                scrollable
                                style="
                                  max-height: 750px !important;
                                  background-color: white;
                                "
                              >
                                <div class="DataTable">
                                  <v-layout>
                                    <v-flex
                                      xs11
                                      pa-2
                                      style="font-size: 20px !important"
                                    >
                                      Spisak barika
                                    </v-flex>
                                  </v-layout>

                                  <v-layout column>
                                    <v-flex
                                      style="
                                        overflow: auto;
                                        max-height: 550px !important;
                                      "
                                    >
                                      <v-data-table
                                        :headers="headers_modal_izabrani_barici"
                                        :items="
                                          props.item.tankFromBatchInOperations
                                        "
                                        hide-actions
                                        class="elevation-1"
                                        show-select
                                        dense
                                        select-all
                                        :pagination.sync="pagination"
                                      >
                                        <template
                                          slot="headers"
                                          slot-scope="props_modal"
                                        >
                                          <tr>
                                            <th
                                              style="
                                                text-align: center;
                                                padding: 5px;
                                              "
                                              v-for="header in props_modal.headers"
                                              :key="header.text"
                                            >
                                              {{ header.text }}
                                            </th>
                                          </tr>
                                        </template>
                                        <template
                                          slot="items"
                                          slot-scope="props_modal"
                                        >
                                          <tr>
                                            <td
                                              style="
                                                text-align: center;
                                                padding-left: 5px;
                                                padding-right: 5px;
                                              "
                                              v-if="
                                                props_modal.item.tank
                                                  .batchPrefix !== null &&
                                                props_modal.item.tank
                                                  .batchPrefix !== ''
                                              "
                                            >
                                              {{
                                                props_modal.item.tank
                                                  .batchPrefix
                                              }}
                                            </td>
                                            <td
                                              style="
                                                text-align: center;
                                                padding-left: 5px;
                                                padding-right: 5px;
                                              "
                                              v-else
                                            >
                                              -
                                            </td>
                                            <td
                                              style="
                                                text-align: center;
                                                padding-left: 5px;
                                                padding-right: 5px;
                                              "
                                            >
                                              {{ props_modal.item.tank.name }}
                                            </td>
                                            <td
                                              style="
                                                text-align: center;
                                                padding-left: 5px;
                                                padding-right: 5px;
                                              "
                                            >
                                              {{
                                                props_modal.item.tank
                                                  .inventoryNumber
                                              }}
                                            </td>
                                            <td
                                              style="
                                                text-align: center;
                                                padding-left: 5px;
                                                padding-right: 5px;
                                              "
                                            >
                                              {{
                                                props_modal.item.tank.capacity +
                                                " " +
                                                props_modal.item.tank
                                                  .unitOfMeasure.mark
                                              }}
                                            </td>
                                          </tr>
                                        </template>
                                      </v-data-table>
                                    </v-flex>
                                  </v-layout>
                                </div>
                              </v-container>
                            </span>
                          </template>
                        </v-menu>
                      </td>
                      <td
                        class="justify-center align-content-center pa-2 text-xs-center"
                        style="padding-right: 0px !important"
                        v-else-if="
                          props.item.tankFromBatchInOperations.length === 1
                        "
                      >
                        <template
                          v-if="
                            props.item.tankFromBatchInOperations[0].tank
                              .inventoryNumber !== null &&
                            props.item.tankFromBatchInOperations[0].tank
                              .inventoryNumber !== ''
                          "
                        >
                          {{
                            props.item.tankFromBatchInOperations[0].tank
                              .batchPrefix +
                            " | " +
                            props.item.tankFromBatchInOperations[0].tank.name +
                            " | " +
                            props.item.tankFromBatchInOperations[0].tank
                              .inventoryNumber
                          }}
                        </template>
                        <template v-else>
                          {{
                            props.item.tankFromBatchInOperations[0].tank
                              .batchPrefix +
                            " | " +
                            props.item.tankFromBatchInOperations[0].tank.name
                          }}
                        </template>
                      </td>
                      <td
                        class="justify-center align-content-center pa-2 text-xs-center"
                        style="padding-right: 2% !important"
                        v-else
                      >
                        {{ "Svi barici" }}
                      </td>
                    </template>
                    <td
                      style="
                        text-align: center;
                        padding-left: 5px;
                        padding-right: 5px;
                      "
                    >
                      {{ props.item.name }}
                    </td>

                    <td
                      style="
                        text-align: center;
                        padding-left: 5px;
                        padding-right: 5px;
                      "
                    >
                      {{
                        props.item.quantity +
                        " " +
                        props.item.unitOfMeasure.replace("psc", "kom")
                      }}
                    </td>
                    <!-- <td style="text-align:center; padding-left:5px; padding-right:5px;">{{ props.item.tankName }}</td> -->
                    <td
                      style="
                        text-align: center;
                        padding-left: 5px;
                        padding-right: 5px;
                      "
                    >
                      <a
                        v-if="props.item.active"
                        v-on:click="
                          routerLinkToDetails(
                            props.item.tankPhaseWineId,
                            props.item.tankId,
                            props.item.active
                          )
                        "
                        >{{ props.item.tankName }}</a
                      >
                      <a
                        v-else
                        style="color: grey"
                        v-on:click="
                          routerLinkToDetails(
                            props.item.tankPhaseWineId,
                            props.item.tankId,
                            props.item.active
                          )
                        "
                        >{{ props.item.tankName }}</a
                      >
                    </td>
                    <td
                      style="
                        text-align: center;
                        padding-left: 5px;
                        padding-right: 5px;
                      "
                    >
                      {{ props.item.phaseAtMoment }}
                    </td>
                    <td>{{ props.item.wineAtMoment }}</td>
                    <td
                      style="
                        text-align: center;
                        padding-left: 5px;
                        padding-right: 5px;
                      "
                    >
                      {{
                        props.item.wineQuantityAtMoment +
                        " " +
                        props.item.wineQuantityAtMomentUnitOfMeasure
                      }}
                    </td>
                    <td>{{ props.item.description }}</td>
                  </template>
                </v-data-table>
              </v-flex>
            </v-layout>

            <!-- <v-container fluid style="padding-top: 10px; padding-bottom: 10px">
              <Timeline />
            </v-container> -->
          </div>
        </v-app>
      </v-container>
    </div>
    <v-dialog
      v-model="dialogNote"
      scrollable
      content-class="ModalInModal"
      persistent
    >
      <v-container style="padding: 0px">
        <div class="DataTable">
          <div data-v-fae5bece class="v-card">
            <div
              data-v-fae5bece
              class="v-card__title headline lighten-2 v-card__title--primary"
              style="padding-left: 30px; padding-bottom: 0px"
            >
              <!-- Modal Titles  -->

              <div>Željene vrednosti temperature (°C)</div>

              <button
                id="closeModalBtn"
                @click.prevent="closeModal"
                class="v-btn v-btn--flat white"
              >
                <v-icon>close</v-icon>
              </button>
            </div>

            <div data-v-fae5bece class="spacer"></div>

            <div v-if="this.dialogNote === true">
              <SetParameterTank
                @mounted="customMounted"
                style="padding-top: 0px"
              />
            </div>
          </div>
        </div>
        <!-- /.addingToTank -->
      </v-container>
    </v-dialog>

    <v-dialog
      v-model="dialogNoteStanjeBarika"
      scrollable
      content-class="ModalInModal"
    >
      <v-container style="padding: 10px">
        <div class="DataTable">
          <v-form ref="form_modal">
            <v-layout>
              <v-flex xs11 pa-2 style="font-size: 20px !important">
                {{ this.naslovKoriscenjeBarika }}
              </v-flex>
              <v-flex xs1 pa-2>
                <a
                  class="closeModalInModalBtn"
                  @click.prevent="closeModalInModalStanjeBarika"
                >
                  <v-icon>close</v-icon>
                </a>
              </v-flex>
            </v-layout>

            <v-layout column>
              <v-flex style="overflow: auto">
                <v-data-table
                  :headers="headers_modal_stanje_barika"
                  :items="items_modal_stanje_barika"
                  hide-actions
                  class="elevation-1"
                  :pagination.sync="pagination"
                >
                  <template slot="headers" slot-scope="props_modal">
                    <tr>
                      <th
                        v-for="header in props_modal.headers"
                        :key="header.text"
                        :class="[
                          'column sortable',
                          pagination.descending ? 'desc' : 'asc',
                          header.value === pagination.sortBy ? 'active' : '',
                        ]"
                        @click="changeSort(header.value)"
                      >
                        <v-icon>arrow_upward</v-icon>
                        {{ header.text }}
                      </th>
                    </tr>
                  </template>
                  <template slot="items" slot-scope="props_modal">
                    <tr>
                      <td style="text-align: center; padding: 5px">
                        {{ props_modal.item.wine }}
                      </td>
                      <td style="text-align: center; padding: 5px">
                        {{ props_modal.item.phase }}
                      </td>

                      <td style="text-align: center; padding: 5px">
                        {{ props_modal.item.batchName }}
                      </td>
                      <td style="text-align: center; padding: 0px">
                        {{ formatDateTime(props_modal.item.from) }}
                      </td>
                      <td style="text-align: center; padding: 0px">
                        {{ formatDateTime(props_modal.item.to) }}
                      </td>

                      <td
                        style="text-align: center; padding: 5px"
                        v-if="props_modal.item.years > 0"
                      >
                        {{
                          "    " +
                          props_modal.item.years +
                          " g    " +
                          props_modal.item.months +
                          " m"
                        }}
                      </td>
                      <td style="text-align: center; padding: 5px" v-else>
                        {{ "    " + props_modal.item.months + " m" }}
                      </td>
                    </tr>
                  </template>
                  <template slot="no-data">
                    <v-alert
                      slot="no-results"
                      :value="true"
                      color="primary"
                      icon="info"
                      >Nema podataka.</v-alert
                    >
                  </template>
                </v-data-table>
              </v-flex>
            </v-layout>
          </v-form>
        </div>
      </v-container>
    </v-dialog>

    <v-dialog
      v-model="dialogNote2"
      scrollable
      content-class="ModalInModal"
      persistent
    >
      <v-container style="padding: 0px">
        <div class="DataTable">
          <div data-v-fae5bece class="v-card">
            <div
              data-v-fae5bece
              class="v-card__title headline lighten-2 v-card__title--primary"
              style="padding-left: 30px; padding-bottom: 0px"
            >
              <!-- Modal Titles  -->

              <div>Parametri fermentacije</div>

              <button
                id="closeModalBtn"
                @click.prevent="closeModal2"
                class="v-btn v-btn--flat white"
              >
                <v-icon>close</v-icon>
              </button>
            </div>

            <div data-v-fae5bece class="spacer"></div>

            <div v-if="this.dialogNote2 === true">
              <SugarTemperatureTank
                @mounted="customMounted2"
                style="padding-top: 0px"
              />
            </div>
          </div>
        </div>
        <!-- /.addingToTank -->
      </v-container>
    </v-dialog>

    <v-dialog
      v-model="dialogNote3"
      scrollable
      content-class="ModalInModal"
      persistent
    >
      <v-container style="padding: 0px">
        <div class="DataTable">
          <div data-v-fae5bece class="v-card">
            <div
              data-v-fae5bece
              class="v-card__title headline lighten-2 v-card__title--primary"
              style="padding-left: 30px; padding-bottom: 0px"
            >
              <!-- Modal Titles  -->

              <div>Komentari</div>

              <button
                id="closeModalBtn"
                @click.prevent="closeModal3"
                class="v-btn v-btn--flat white"
              >
                <v-icon>close</v-icon>
              </button>
            </div>

            <div data-v-fae5bece class="spacer"></div>

            <div v-if="this.dialogNote3 === true">
              <SetComment @mounted="customMounted3" style="padding-top: 0px" />
            </div>
          </div>
        </div>
        <!-- /.addingToTank -->
      </v-container>
    </v-dialog>

    <v-dialog
      v-model="dialogNote4"
      scrollable
      content-class="ModalInModal"
      persistent
    >
      <v-container style="padding: 0px">
        <div class="DataTable">
          <div data-v-fae5bece class="v-card">
            <div
              data-v-fae5bece
              class="v-card__title headline lighten-2 v-card__title--primary"
              style="padding-left: 30px; padding-bottom: 0px"
            >
              <!-- Modal Titles  -->

              <div>Faze</div>

              <button
                id="closeModalBtn"
                @click.prevent="closeModal4"
                class="v-btn v-btn--flat white"
              >
                <v-icon>close</v-icon>
              </button>
            </div>

            <div data-v-fae5bece class="spacer"></div>

            <div v-if="this.dialogNote4 === true">
              <SetTankPhase
                @mounted="customMounted4"
                style="padding-top: 0px"
              />
            </div>
          </div>
        </div>
        <!-- /.addingToTank -->
      </v-container>
    </v-dialog>

    <v-dialog
      v-model="dialogNote5"
      scrollable
      content-class="ModalInModal"
      persistent
    >
      <v-container style="padding: 0px">
        <div class="DataTable">
          <div data-v-fae5bece class="v-card">
            <div
              data-v-fae5bece
              class="v-card__title headline lighten-2 v-card__title--primary"
              style="padding-left: 30px; padding-bottom: 0px"
            >
              <!-- Modal Titles  -->

              <div>Vina</div>

              <button
                id="closeModalBtn"
                @click.prevent="closeModal5"
                class="v-btn v-btn--flat white"
              >
                <v-icon>close</v-icon>
              </button>
            </div>

            <div data-v-fae5bece class="spacer"></div>

            <div v-if="this.dialogNote5 === true">
              <SetTankWine
                @mounted="customMounted5"
                style="padding-top: 0px"
                :wineType="this.items.wine.wineLabel.wineType.id"
              />
            </div>
          </div>
        </div>
        <!-- /.addingToTank -->
      </v-container>
    </v-dialog>

    <v-dialog
      v-model="dialogNoteGrafic"
      scrollable
      content-class="ModalInModalGrafic"
      persistent
    >
      <v-container style="padding: 0px">
        <div class="DataTable">
          <div data-v-fae5bece class="v-card">
            <div
              data-v-fae5bece
              class="v-card__title headline lighten-2 v-card__title--primary"
              style="padding-left: 30px; padding-bottom: 0px"
            >
              <!-- Modal Titles  -->

              <div>Parametri fermentacije</div>

              <button
                id="closeModalBtn"
                @click.prevent="closeModalGrafic"
                class="v-btn v-btn--flat white"
              >
                <v-icon>close</v-icon>
              </button>
            </div>

            <div data-v-fae5bece class="spacer"></div>

            <div v-if="this.dialogNoteGrafic === true">
              <Grafik @mounted="customMountedGrafic" style="padding-top: 0px" />
            </div>
          </div>
        </div>
        <!-- /.addingToTank -->
      </v-container>
    </v-dialog>

    <v-dialog
      v-model="dialogNote_izabrani_tankovi"
      scrollable
      content-class="ModalInModalSrednji"
      persistent
    >
      <v-container>
        <div class="DataTable">
          <v-form ref="form_modal">
            <v-layout>
              <v-flex xs11 pa-2 style="font-size: 20px !important">
                Spisak barika u šarži - {{ this.items.tank.name }}
              </v-flex>
              <v-flex xs1 pa-2>
                <a
                  class="closeModalInModalBtn"
                  @click.prevent="closeModalInModal_izabrani_tankovi"
                >
                  <v-icon>close</v-icon>
                </a>
              </v-flex>
            </v-layout>

            <v-layout column>
              <v-flex style="overflow: auto">
                <v-data-table
                  :headers="headers_modal_izabrani_tankovi"
                  :items="items_modal_izabrani_tankovi"
                  hide-actions
                  :pagination.sync="pagination"
                >
                  <template slot="headers" slot-scope="props_modal">
                    <tr>
                      <th
                        style="text-align: center; padding: 5px"
                        v-for="header in props_modal.headers"
                        :key="header.text"
                        :class="[
                          'column sortable',
                          pagination.descending ? 'desc' : 'asc',
                          header.value === pagination.sortBy ? 'active' : '',
                        ]"
                        @click="changeSort(header.value)"
                      >
                        <v-icon>arrow_upward</v-icon>
                        {{ header.text }}
                      </th>
                    </tr>
                  </template>
                  <!-- : -->
                  <template slot="items" slot-scope="props_modal">
                    <template v-if="props_modal.item.empty">
                      <tr>
                        <td
                  style="
                    text-align: center;
                    padding-left: 5px;
                    padding-right: 5px;
                  "
                >
                  {{
                    items_modal_izabrani_tankovi
                      .map(function (x) {
                        return x.id;
                      })
                      .indexOf(props_modal.item.id) + 1
                  }}
                </td>
                        <td
                          style="
                            text-align: center;
                            padding-left: 5px;
                            padding-right: 5px;
                            display: none;
                          "
                        >
                          {{ props_modal.item.empty }}
                        </td>
                        <td
                          style="
                            text-align: center;
                            padding-left: 5px;
                            padding-right: 5px;
                            background: #f3f7f4;
                          "
                          v-if="
                            props_modal.item.batchPrefix !== null &&
                            props_modal.item.batchPrefix !== ''
                          "
                        >
                          {{
                            props_modal.item.batchPrefix +
                            " - " +
                            props_modal.item.tankNumberInBatch
                          }}
                        </td>
                        <td
                          style="
                            text-align: center;
                            padding-left: 5px;
                            padding-right: 5px;
                            background: #f3f7f4;
                          "
                          v-else
                        >
                          {{ props_modal.item.tankNumberInBatch }}
                        </td>
                        <td
                          style="
                            text-align: center;
                            padding-left: 5px;
                            padding-right: 5px;
                          "
                        >
                          {{ props_modal.item.tank.name }}
                        </td>
                        <td
                          style="
                            text-align: center;
                            padding-left: 5px;
                            padding-right: 5px;
                          "
                        >
                          {{ props_modal.item.tank.inventoryNumber }}
                        </td>
                        <td
                          style="
                            text-align: center;
                            padding-left: 0px;
                            padding-right: 0px;
                          "
                        >
                          {{ formatDate1(props_modal.item.tank.bayingDate) }}
                        </td>
                        <td
                          style="
                            text-align: center;
                            padding-left: 5px;
                            padding-right: 5px;
                          "
                        >
                          {{
                            props_modal.item.tank.capacity +
                            " " +
                            props_modal.item.tank.unitOfMeasure.mark
                          }}
                        </td>

                        <td
                          style="
                            text-align: center;
                            padding-left: 5px;
                            padding-right: 5px;
                          "
                          v-if="props_modal.item.tank.materialType !== null"
                        >
                          {{ props_modal.item.tank.materialType }}
                        </td>
                        <td v-else>{{ "" }}</td>
                        <td
                          style="
                            text-align: center;
                            padding-left: 5px;
                            padding-right: 5px;
                          "
                          v-if="props_modal.item.tank.producer !== null"
                        >
                          {{ props_modal.item.tank.producer }}
                        </td>
                        <td v-else>{{ "" }}</td>
                        <td
                          style="
                            text-align: center;
                            padding-left: 5px;
                            padding-right: 5px;
                          "
                        >
                          <img
                            class="DataTable__Button"
                            title="Pregled korišćenja barika"
                            src="../assets/icons/zatabele/ico-options.svg"
                            alt="delete-item"
                            @click="otvoriDialog(props_modal.item)"
                          />
                        </td>
                      </tr>
                    </template>
                    <template v-else>
                      <tr>
                        <td
                          style="
                            text-align: center;
                            padding-left: 5px;
                            padding-right: 5px;
                            display: none;
                          "
                        >
                          {{ props_modal.item.empty }}
                        </td>
                        <td
                  style="
                    text-align: center;
                    padding-left: 5px;
                    padding-right: 5px;
                  "
                >
                  {{
                    items_modal_izabrani_tankovi
                      .map(function (x) {
                        return x.id;
                      })
                      .indexOf(props_modal.item.id) + 1
                  }}
                </td>
                        <td
                          style="
                            text-align: center;
                            padding-left: 5px;
                            padding-right: 5px;
                          "
                          v-if="
                            props_modal.item.batchPrefix !== null &&
                            props_modal.item.batchPrefix !== ''
                          "
                        >
                          {{
                            props_modal.item.batchPrefix +
                            " - " +
                            props_modal.item.tankNumberInBatch
                          }}
                        </td>
                        <td
                          style="
                            text-align: center;
                            padding-left: 5px;
                            padding-right: 5px;
                          "
                          v-else
                        >
                          {{ props_modal.item.tankNumberInBatch }}
                        </td>
                        <td
                          style="
                            text-align: center;
                            padding-left: 5px;
                            padding-right: 5px;
                          "
                        >
                          {{ props_modal.item.tank.name }}
                        </td>
                        <td
                          style="
                            text-align: center;
                            padding-left: 5px;
                            padding-right: 5px;
                          "
                        >
                          {{ props_modal.item.tank.inventoryNumber }}
                        </td>
                        <td
                          style="
                            text-align: center;
                            padding-left: 0px;
                            padding-right: 0px;
                          "
                        >
                          {{ formatDate1(props_modal.item.tank.bayingDate) }}
                        </td>
                        <td
                          style="
                            text-align: center;
                            padding-left: 5px;
                            padding-right: 5px;
                          "
                        >
                          {{
                            props_modal.item.tank.capacity +
                            " " +
                            props_modal.item.tank.unitOfMeasure.mark
                          }}
                        </td>

                        <td
                          style="
                            text-align: center;
                            padding-left: 5px;
                            padding-right: 5px;
                          "
                          v-if="props_modal.item.tank.materialType !== null"
                        >
                          {{ props_modal.item.tank.materialType }}
                        </td>
                        <td v-else>{{ "" }}</td>
                        <td
                          style="
                            text-align: center;
                            padding-left: 5px;
                            padding-right: 5px;
                          "
                          v-if="props_modal.item.tank.producer !== null"
                        >
                          {{ props_modal.item.tank.producer }}
                        </td>
                        <td v-else>{{ "" }}</td>
                        <td
                          style="
                            text-align: center;
                            padding-left: 5px;
                            padding-right: 5px;
                          "
                        >
                          <img
                            class="DataTable__Button"
                            title="Pregled korišćenja barika"
                            src="../assets/icons/zatabele/ico-options.svg"
                            alt="delete-item"
                            @click="otvoriDialog(props_modal.item)"
                          />
                        </td>
                      </tr>
                    </template>
                  </template>
                  <template slot="no-data">
                    <!-- <v-btn color="primary" @click="initialize">Reset</v-btn> -->
                    <v-alert
                      slot="no-results"
                      :value="true"
                      color="primary"
                      icon="info"
                      >Nema podataka.</v-alert
                    >
                  </template>
                </v-data-table>
              </v-flex>
              <v-flex xs11 pa-2 style="font-size: 12px !important">
                Osenčeni barici su ispražnjeni
              </v-flex>
            </v-layout>
          </v-form>
        </div>
      </v-container>
    </v-dialog>
    <!--  -->
    <!-- /.Actions__Content -->
    <TokenComponent ref="frmtoken" />
  </div>
</template>

<script>
import * as am4core from "@amcharts/amcharts4/core";
import * as am4charts from "@amcharts/amcharts4/charts";
import * as am4plugins_sunburst from "@amcharts/amcharts4/plugins/sunburst";
import am4themes_animated from "@amcharts/amcharts4/themes/animated";

am4core.useTheme(am4themes_animated);

import { serverBus } from "../main";
import {
  readJSON,
  prevediSveOperacije,
  getDateTime,
} from "../helpers/Functions";

import Breadcrumbs from "../components/layoutComponents/Breadcrumbs";
import ActionsNav from "./parts/ActionsNav";

import html2pdf from "html2pdf.js";

// import Timeline from "./Timeline";

import SetParameterTank from "./SetParameterTank";
import SugarTemperatureTank from "./SugarTemperatureTank";
import SetComment from "./SetComment";
import SetTankPhase from "./SetTankPhase";
import SetTankWine from "./SetTankWine";
import Grafik from "./Grafik";

import TokenComponent from "../components/Token";

import Loading from "vue-loading-overlay";

import MultiButtonSingleTank from "./parts/MultiButtonSingleTank";
import FloatingButtonMultiSingleTank from "./parts/FloatingButtonMultiSingleTank";

const MountedMixin = {
  mounted() {
    // alert(1);
    this.$emit("mounted");
  },
};

export default {
  name: "singleTank",
  dialog: false,
  components: {
    Breadcrumbs,
    TokenComponent,
    Loading,
    MultiButtonSingleTank,
    FloatingButtonMultiSingleTank,
    // Timeline,
    ActionsNav,
    SetParameterTank: (resolve) => {
      setTimeout(() => {
        const component = SetParameterTank;
        component.mixins = [];
        component.mixins.push(MountedMixin);
        resolve(component);
        // This could be the result of System.import of an async require
      }, 300);
    },
    SugarTemperatureTank: (resolve) => {
      setTimeout(() => {
        const component = SugarTemperatureTank;
        component.mixins = [];
        component.mixins.push(MountedMixin);
        resolve(component);
        // This could be the result of System.import of an async require
      }, 300);
    },
    SetComment: (resolve) => {
      setTimeout(() => {
        const component = SetComment;
        component.mixins = [];
        component.mixins.push(MountedMixin);
        resolve(component);
        // This could be the result of System.import of an async require
      }, 300);
    },
    SetTankPhase: (resolve) => {
      setTimeout(() => {
        const component = SetTankPhase;
        component.mixins = [];
        component.mixins.push(MountedMixin);
        resolve(component);
        // This could be the result of System.import of an async require
      }, 300);
    },
    SetTankWine: (resolve) => {
      setTimeout(() => {
        const component = SetTankWine;
        component.mixins = [];
        component.mixins.push(MountedMixin);
        resolve(component);
        // This could be the result of System.import of an async require
      }, 300);
    },
    Grafik: (resolve) => {
      setTimeout(() => {
        const component = Grafik;
        component.mixins = [];
        component.mixins.push(MountedMixin);
        resolve(component);
        // This could be the result of System.import of an async require
      }, 300);
    },
  },
  data() {
    return {
      naslovIzvestaja:"",
      administrator: undefined,
      search: "",
      search_merenja: "",
      actionId: 0,
      selectedTab: 0,
      selectedTabDodaci: 0,
      selectedTabMerenja: 0,
      pagination: {
        sortBy: "date",
        rowsPerPage: 10000000,
      },
      paginationMerenja: {
        sortBy: "date",
        rowsPerPage: 10000000,
      },
      paginationDodaci: {
        sortBy: "date",
        rowsPerPage: 10000000,
      },
      items: {
        tank: {
          name: "",
          tankType: {
            name: "tank-inox",
            description: "",
          },
          description: "",
          unitOfMeasure: {
            name: "",
          },
          currency: {
            name: "",
          },
          room: {
            name: "",
          },
        },
        phase: {
          name: "",
        },
        wine: {
          name: "",
          year: "",
          wineLabel: {
            wineType: {
              id: 0,
              name: "",
            },
          },
        },
        quantityUnitOfMeasure: {
          mark: "",
        },
      },
      all_grape_input_items: [],
      tank_phase_vineId: 0,
      tankId: 0,
      phaseId: 0,
      wineId: 0,
      phaseMark: "",
      kolicina_vina_u_bacvi: 0,
      akcija: 0,
      // treba brisati na celoj strani
      disabled_phase: false,
      headers_merenja_init: [
        { text: "" },
        { text: "Datum", value: "date", align: "left" },
        { text: "Parametar", value: "name", align: "center" },
        { text: "Količina", value: "quantity", align: "center" },
        { text: "Tank", value: "tankName", align: "center" },
        { text: "Faza", value: "phaseAtMoment", align: "center" },
        { text: "Vino", value: "wineAtMoment", align: "left" },
        {
          text: "Količina vina",
          value: "wineQuantityAtMoment",
          align: "center",
        },
        { text: "Opis", value: "description", align: "left" },
      ],
      headers_merenja: [
        { text: "" },
        { text: "Datum", value: "date", align: "left" },
        { text: "Parametar", value: "name", align: "center" },
        { text: "Količina", value: "quantity", align: "center" },
        { text: "Tank", value: "tankName", align: "center" },
        { text: "Faza", value: "phaseAtMoment", align: "center" },
        { text: "Vino", value: "wineAtMoment", align: "left" },
        {
          text: "Količina vina",
          value: "wineQuantityAtMoment",
          align: "center",
        },
        { text: "Opis", value: "description", align: "left" },
      ],
      headers_merenja_sarza: [
        { text: "" },
        { text: "Datum", value: "date", align: "left" },
        { text: "Barik", value: "name", align: "center" },
        { text: "Parametar", value: "name", align: "center" },
        { text: "Količina", value: "quantity", align: "center" },
        { text: "Tank", value: "tankName", align: "center" },
        { text: "Faza", value: "phaseAtMoment", align: "center" },
        { text: "Vino", value: "wineAtMoment", align: "left" },
        {
          text: "Količina vina",
          value: "wineQuantityAtMoment",
          align: "center",
        },
        { text: "Opis", value: "description", align: "left" },
      ],
      items_merenja: [],
      items_merenja_init: [],
      items_merenja_prev: [],
      headers_dodaci: [
        { text: "", sortable: false },
        { text: "Datum", value: "date", align: "left" },
        { text: " ", sortable: false },
        { text: "Dodatak", value: "name", align: "center" },
        { text: "Količina", value: "quantity", align: "center" },
        { text: "Tank", value: "tankName", align: "center" },
        { text: "Faza", value: "phaseAtMoment", align: "center" },
        { text: "Vino", value: "wineAtMoment", align: "left" },
        { text: "Na količinu", value: "wineQuantityAtMoment", align: "center" },
        { text: "Opis", value: "description", align: "left" },
      ],
      headers_dodaci_init: [
        { text: "", sortable: false },
        { text: "Datum", value: "date", align: "left" },
        { text: " ", sortable: false },
        { text: "Dodatak", value: "name", align: "center" },
        { text: "Količina", value: "quantity", align: "center" },
        { text: "Tank", value: "tankName", align: "center" },
        { text: "Faza", value: "phaseAtMoment", align: "center" },
        { text: "Vino", value: "wineAtMoment", align: "left" },
        { text: "Na količinu", value: "wineQuantityAtMoment", align: "center" },
        { text: "Opis", value: "description", align: "left" },
      ],
      headers_dodaci_sarza: [
        { text: "", sortable: false },
        { text: "Datum", value: "date", align: "left" },
        { text: " ", sortable: false },
        { text: "Barik", value: "name", align: "center" },
        { text: "Dodatak", value: "name", align: "center" },
        { text: "Količina", value: "quantity", align: "center" },
        { text: "Tank", value: "tankName", align: "center" },
        { text: "Faza", value: "phaseAtMoment", align: "center" },
        { text: "Vino", value: "wineAtMoment", align: "left" },
        { text: "Na količinu", value: "wineQuantityAtMoment", align: "center" },
        { text: "Opis", value: "description", align: "left" },
      ],
      headers_inputoutput: [
        { text: "" },
        { text: "Datum", value: "date", align: "center" },
        { text: "Faza", value: "phaseAtMoment", align: "center" },
        { text: "Vino", value: "wineAtMoment", align: "center" },
        { text: "Operacija", value: "operation", align: "center" },
        { text: "Iz tanka", value: "tankName", align: "center" },
        { text: "U tank", value: "tankName", align: "center" },
        { text: "Količina", value: "quantity", align: "center" },
        { text: "Talog", value: "sediment", align: "left" },
        { text: "Rastur", value: "outage", align: "left" },
        { text: "Opis", value: "description", align: "left" },
      ],
      headers_modal_izabrani_barici: [
        { text: "Oznaka barika", value: "tankNumberInBatch", align: "center" },
        { text: "Naziv", value: "tank.name", align: "center" },
        {
          text: "Inventarni broj",
          value: "tank.inventoryNumber",
          align: "center",
        },
        { text: "Kapacitet", value: "tank.capacity", align: "center" },
      ],
      items_dodaci: [],
      items_dodaci_init: [],
      items_dodaci_prev: [],
      items_grafici: [],
      tank_phase_vineId_grafik: 0,
      items_inputoutput: [],
      prikazi_faze: false,
      prikazi_vina: false,
      phase_to_items_pom: [],
      wine_to_items: [],
      phase_to_select: "",
      wine_to_select: "",
      dialogNote: false,
      dialogNote2: false,
      dialogNote3: false,
      dialogNote4: false,
      dialogNote5: false,
      dialogNoteGrafic: false,
      zeljena_temperatura: "",
      trenutna_temperatura: "",
      trenutno_secera: "",
      poslednja_temperatura: "",
      poslednji_komentar: "",
      prazan_tank: 0,
      tip_tanka: 0,
      tip_tanka_naziv: "",
      items_modal_izabrani_tankovi: [],
      headers_modal_izabrani_tankovi_2: [
        { text: "Oznaka barika", value: "tankNumberInBatch", align: "center" },
        { text: "Naziv", value: "tank.name", align: "center" },
        {
          text: "Inventarni broj",
          value: "tank.inventoryNumber",
          align: "center",
        },
        { text: "Kapacitet", value: "tank.capacity", align: "center" },
      ],
      headers_modal_izabrani_tankovi: [
        { text: "Rb", value: "", align: "center" },
        // { text: "Prazan", value: "empty", align: "center" },
        { text: "Oznaka barika", value: "tankNumberInBatch", align: "center" },
        { text: "Naziv", value: "tank.name", align: "center" },
        {
          text: "Inventarni broj",
          value: "tank.inventoryNumber",
          align: "center",
        },
        { text: "Datum nabavke", value: "tank.bayingDate", align: "center" },
        { text: "Kapacitet", value: "tank.capacity", align: "center" },
        // { text: "JM", value: "width" },
        { text: "Materijal", value: "tank.materialType", align: "center" },
        { text: "Proizvođač", value: "tank.producer", align: "center" },
        { text: "Funkcije", value: "funkcije", align: "left", sortable: false },
      ],
      headers_modal_stanje_barika: [
        { text: "Vino", value: "wine" },
        { text: "Faza", value: "phase" },
        { text: "Šarža", value: "batchName" },
        { text: "Od", value: "from" },
        { text: "Do", value: "to" },
        { text: "Odležavalo", value: "wineType" },
      ],
      dialogNote_izabrani_tankovi: false,
      dozvoljena_izmena: 1,
      data_grape_variety_parts: [],
      items_modal_stanje_barika: [],
      dialogNoteStanjeBarika: false,
      naslovKoriscenjeBarika: "Pregled koriscenja barika",
      broj_barika: "",
      selectedItem: false,
      title_broj_barika: "",
      naziv_fajla: "",
      naslov: "",
      json_fields_type: [],
      json_fields: {},
      json_data: [],
      isLoading: false,
      fullPage: true,

      cena: "",
    };
  },

  methods: {
    daLiJeAdmin() {
      let odgovor = false;

      let pomStr = localStorage.getItem("role");

      if (pomStr === "admin") {
        odgovor = true;
        this.cenaKostanja();
      }
      
      return odgovor;
    },
    proracunajTrajanje(datumOd, datumDo) {
      let odgovor = "";

      if (datumDo !== null) {
        const date1 = new Date(datumOd);
        const date2 = new Date(datumDo);

        const diffTime = Math.abs(date2 - date1);
        const diffYears =
          Math.ceil(diffTime / (1000 * 60 * 60 * 24 * 30 * 12)) - 1;

        const diffMonths =
          Math.ceil(
            (diffTime - diffYears * 1000 * 60 * 60 * 24 * 30 * 12) /
              (1000 * 60 * 60 * 24 * 30)
          ) - 1;

        const diffDays =
          Math.ceil(
            (diffTime -
              diffYears * 1000 * 60 * 60 * 24 * 30 * 12 -
              diffMonths * 1000 * 60 * 60 * 24 * 30) /
              (1000 * 60 * 60 * 24)
          ) - 1;

        odgovor =
          (diffDays !== 0 ? diffDays + " d " : "") +
          (diffMonths !== 0 ? diffMonths + " m " : "") +
          (diffYears !== 0 ? diffYears + " g" : "");

        if (odgovor.substring(odgovor.length - 1, odgovor.length) === " ")
          odgovor = odgovor.substring(0, odgovor.length - 1);
      }

      return odgovor;
    },
    cenaKostanja() {
      this.isLoading = true;

      this.$http
        .get(
          this.globalServiceLocation +
            this.globalPort +
            "/wine/wine_production_costs/" +
            this.tank_phase_vineId,
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: "Bearer  " + localStorage.getItem("user-token"),
            },
          }
        )
        .then((response) => {
          if (response.data.productionPricePerL !== null)
            this.cena =
              this.currencyFormatDE(response.data.productionPricePerL) +
              " RSD/L";
          else this.cena = "-";

          this.isLoading = false;
        })
        .catch((e) => {
          if (!e.response) {
            alert(
              this.$t("error.message")
            );
          } else {
            if (e.response.status === 401) {
              this.$refs.frmtoken
                .osvezavanjeTokena(localStorage.getItem("user-refresh-token"))
                .then((result) => {
                  this.$http
                    .get(
                      this.globalServiceLocation +
                        this.globalPort +
                        "/wine/wine_production_costs/" +
                        this.tank_phase_vineId,
                      {
                        headers: {
                          "Content-Type": "application/json",
                          Authorization:
                            "Bearer  " + localStorage.getItem("user-token"),
                        },
                      }
                    )
                    .then((response) => {
                      if (response.data.productionPricePerL !== null)
                        this.cena =
                          this.currencyFormatDE(
                            response.data.productionPricePerL
                          ) + " RSD/L";
                      else this.cena = "-";

                      this.isLoading = false;
                    })
                    .catch((e) => {
                      let pomError = readJSON(e.response.data.message);
                      alert(pomError);
                      this.isLoading = false;
                    });
                });
            } else {
              let pomError = readJSON(e.response.data.message);
              alert(pomError);
              this.isLoading = false;
            }
          }
        });
    },
    otvoriDialog(item) {
      //scrollToTop(300);
      let pomitem;

      if (item !== null) pomitem = item;
      else pomitem = this.items;

      this.items_modal_stanje_barika = [];

      this.dialogNoteStanjeBarika = true;
      this.getAllSifarnikStanjeBarika(pomitem.tank.id);

      this.naslovKoriscenjeBarika =
        "Pregled korišćenja barika - " + pomitem.tank.name;
    },
    getAllSifarnikStanjeBarika(tankId) {
      this.$http
        .get(
          this.globalServiceLocation +
            this.globalPort +
            "/tank/barique_history/" +
            tankId,
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: "Bearer  " + localStorage.getItem("user-token"),
            },
          }
        )
        .then((response) => {
          console.log(response.data);

          this.items_modal_stanje_barika = response.data;
        })
        .catch((e) => {
          if (!e.response) {
            alert(
              this.$t("error.message")
            );
          } else {
            if (e.response.status === 401) {
              this.$refs.frmtoken
                .osvezavanjeTokena(localStorage.getItem("user-refresh-token"))
                .then((result) => {
                  this.$http
                    .get(
                      this.globalServiceLocation +
                        this.globalPort +
                        "/tank/barique_history/" +
                        tankId,
                      {
                        headers: {
                          "Content-Type": "application/json",
                          Authorization:
                            "Bearer  " + localStorage.getItem("user-token"),
                        },
                      }
                    )
                    .then((response) => {
                      this.items_modal_stanje_barika = response.data;
                    })
                    .catch((e) => {
                      let pomError = readJSON(e.response.data.message);
                      alert(pomError);
                    });
                });
            } else {
              let pomError = readJSON(e.response.data.message);
              alert(pomError);
            }
          }
        });
    },
    closeModalInModalStanjeBarika() {
      this.items_modal_stanje_barika = [];

      this.dialogNoteStanjeBarika = false;
    },
    ucitajGrafik: function () {
      let chart = am4core.create(
        this.$refs.chartdiv,
        am4plugins_sunburst.Sunburst
      );

      chart.data = this.data_grape_variety_parts;

      chart.padding(10, 10, 10, 10);
      // chart.radius = am4core.percent(98);

      chart.colors.step = 2;
      chart.fontSize = 9;
      chart.innerRadius = am4core.percent(10);

      // Define data fields
      chart.dataFields.value = "value";
      chart.dataFields.name = "name";
      chart.dataFields.children = "children";

      // Configure levels
      var level0 = chart.seriesTemplates.create("0");
      level0.labels.template.text = "{category}";

      var level1 = chart.seriesTemplates.create("1");
      level1.slices.template.fillOpacity = 0.75;
      level1.labels.template.radius = 0;
      level1.labels.template.text = "{category}";
      level1.hiddenInLegend = true;

      var level2 = chart.seriesTemplates.create("2");
      level2.slices.template.fillOpacity = 0.5;
      level2.labels.template.text = "{category}";
      level2.labels.template.radius = 0;
      level2.labels.template.inside = true;
      level2.labels.template.fill = am4core.color("#000");
      level2.hiddenInLegend = true;

      // Add legend
      //chart.legend = new am4charts.Legend();

      this.chart = chart;
    },
    currencyFormatDE(num) {
      let odgovor = "";

      if (num !== undefined)
        odgovor = num
          .toFixed(2) // always two decimal digits
          .replace(".", ",") // replace decimal point character with ,
          .replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1."); // use . as a separator

      return odgovor;
    },
    formatDate1(date) {
      if (!date) return null;

      const [year, month, day] = date.split("-");
      return `${day}.${month}.${year}`;
    },
    routerLinkToDetails(lokID, lokIDTank, lokActive) {
      this.$router.push({
        name: "single_tank",
        params: { id: lokID, idTank: lokIDTank, active: lokActive },
      });
    },
    idiNaPrazanTank(lokID, lokIDTank) {
      this.$http
        .get(
          this.globalServiceLocation +
            this.globalPort +
            "/tank/" +
            lokIDTank +
            "/is_tank_empty",
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: "Bearer  " + localStorage.getItem("user-token"),
            },
          }
        )
        .then((response) => {
          // // console.log(response.data);

          if (response.data !== false)
            this.$router.push({
              name: "empty_tank",
              params: { id: lokIDTank },
            });
          else {
            this.getAllSifarnik();
          }
        })
        .catch((e) => {
          if (!e.response) {
            alert(
              this.$t("error.message")
            );
          } else {
            if (e.response.status === 401) {
              this.$refs.frmtoken
                .osvezavanjeTokena(localStorage.getItem("user-refresh-token"))
                .then((result) => {
                  // // console.log(result);
                  // // console.log("Novi token - " + localStorage.getItem("user-token"));

                  this.$http
                    .get(
                      this.globalServiceLocation +
                        this.globalPort +
                        "/tank/" +
                        lokIDTank +
                        "/is_tank_empty",
                      {
                        headers: {
                          "Content-Type": "application/json",
                          Authorization:
                            "Bearer  " + localStorage.getItem("user-token"),
                        },
                      }
                    )
                    .then((response) => {
                      // // console.log(response.data);

                      if (response.data !== false)
                        this.$router.push({
                          name: "empty_tank",
                          params: { id: lokIDTank },
                        });
                      else {
                        this.getAllSifarnik();
                      }
                    })
                    .catch((e) => {
                      // // console.log(e.response);

                      let pomError = readJSON(e.response.data.message);
                      alert(pomError);
                    });
                });
            } else {
              let pomError = readJSON(e.response.data.message);
              alert(pomError);
            }
          }
        });
    },
    stampaj() {
      let _this = this;
      this.isLoading = true;

      this.naziv_fajla = "dodavanja.xls";

      if (this.tip_tanka === 15) {
        if (this.selectedTabDodaci === 0)
          this.naslov = "Dodavanja u šaržu " + this.items.tank.name;
        else
          this.naslov =
            "Prethodna dodavanja u vino iz šarže " + this.items.tank.name;

        this.json_fields = {
          Rb: "String",
          Datum: "Date",
          Barik: "String",
          Dodatak: "String",
          Količina: "Number",
          Tank: "String",
          Faza: "String",
          Vino: "String",
          "Na količinu": "Number",
        };

        this.json_fields_type = [
          "String",
          "Date",
          "String",
          "String",
          "Number",
          "String",
          "String",
          "String",
          "Number",
        ];
      } else {
        if (this.selectedTabDodaci === 0)
          this.naslov = "Dodavanja u tank " + this.items.tank.name;
        else
          this.naslov =
            "Prethodna dodavanja u vino iz tanka " + this.items.tank.name;

        this.json_fields = {
          Rb: "String",
          Datum: "Date",
          Dodatak: "String",
          Količina: "Number",
          Tank: "String",
          Faza: "String",
          Vino: "String",
          "Na količinu": "Number",
        };

        this.json_fields_type = [
          "String",
          "Date",
          "String",
          "Number",
          "String",
          "String",
          "String",
          "Number",
        ];
      }

      this.json_data = [];
      let rbr = 1;

      this.items_dodaci.forEach(function (entry) {
        let objekat;

        if (_this.tip_tanka === 15) {
          let spisakBarika = "";

          if (entry.tankFromBatchInOperations.length > 0)
            entry.tankFromBatchInOperations.forEach(function (e) {
              if (spisakBarika !== "")
                spisakBarika =
                  spisakBarika + ", " + e.tank.batchPrefix + "|" + e.tank.name;
              else spisakBarika = e.tank.batchPrefix + "|" + e.tank.name;
            });
          else spisakBarika = "Svi barici";

          objekat = {
            Rb: rbr,
            Datum:
              _this.formatDateTime(entry.date) +
              (entry.oxygenationEndDate !== null
                ? " (" +
                  _this.proracunajTrajanje(
                    entry.date,
                    entry.oxygenationEndDate
                  ) +
                  ")"
                : ""),
            Barik: spisakBarika,
            Dodatak:
              entry.name +
              (entry.microOrMacro !== null
                ? " (" + entry.microOrMacro + " oksigenacija)"
                : ""),
            Količina: entry.quantity + " " + entry.unitOfMeasure,
            Tank: entry.tankName,
            Faza: entry.phaseAtMoment,
            Vino: entry.wineAtMoment,
            "Na količinu":
              entry.wineQuantityAtMoment +
              " " +
              entry.wineQuantityAtMomentUnitOfMeasure,
          };
        } else
          objekat = {
            Rb: rbr,
            Datum:
              _this.formatDateTime(entry.date) +
              (entry.oxygenationEndDate !== null
                ? " (" +
                  _this.proracunajTrajanje(
                    entry.date,
                    entry.oxygenationEndDate
                  ) +
                  ")"
                : ""),
            Dodatak:
              entry.name +
              (entry.microOrMacro !== null
                ? " (" + entry.microOrMacro + " oksigenacija)"
                : ""),
            Količina: entry.quantity + " " + entry.unitOfMeasure,
            Tank: entry.tankName,
            Faza: entry.phaseAtMoment,
            Vino: entry.wineAtMoment,
            "Na količinu":
              entry.wineQuantityAtMoment +
              " " +
              entry.wineQuantityAtMomentUnitOfMeasure,
          };

        _this.json_data.push(objekat);

        rbr = rbr + 1;
      });

      setTimeout(() => {
        var elementToPrint = document.createElement("div");
        elementToPrint.style.margin = "0px 0px 0px 0px";

        var elementToPrint2 = document.createElement("p");
        elementToPrint2.innerHTML = _this.naslov;

        elementToPrint2.style.position = "relative";
        elementToPrint2.style.textAlign = "center";
        elementToPrint2.style.fontSize = "20px";
        elementToPrint.append(elementToPrint2);

        // var body = document.getElementsByTagName("body")[0];
        var tbl = document.createElement("table");
        var tr = document.createElement("tr"); // Header row
        jQuery.each(_this.json_fields, function (i, val) {
          var th = document.createElement("th"); //column
          var text = "";
          text = document.createTextNode(i);

          th.setAttribute("style", "padding-bottom: 4px;");

          th.appendChild(text);

          tr.appendChild(th);
        });

        tr.style.background = "#eaece5";
        tbl.appendChild(tr);

        var tblBody = document.createElement("tbody");

        let poslednjiRed = null;

        jQuery.each(_this.json_data, function (i, val1) {
          var isLastElement = i == _this.json_data.length - 1;

          var row = document.createElement("tr");

          let pomJ = 0;

          jQuery.each(val1, function (i, val) {
            var cell = document.createElement("td");

            var cellText;

            if (val === null || val === 0 || val === "")
              cellText = document.createTextNode("-");
            else cellText = document.createTextNode(val);

            cell.appendChild(cellText);

            if (i === 1)
              cell.setAttribute(
                "style",
                "text-align :left; padding-left: 5px; padding-bottom: 4px;"
              );
            else if (
              _this.json_fields_type[pomJ] === "Number" ||
              _this.json_fields_type[pomJ] === "StringRight"
            ) {
              cell.setAttribute(
                "style",
                "text-align :right; padding-bottom: 4px; padding-right: 5px;"
              );
            } else if (_this.json_fields_type[pomJ] === "Date") {
              cell.setAttribute(
                "style",
                "text-align :center; padding-bottom: 4px; padding-right: 1px; padding-left: 1px;"
              );
            } else
              cell.setAttribute(
                "style",
                "text-align :center; padding-bottom: 4px;"
              );

            pomJ = pomJ + 1;

            row.appendChild(cell);
          });

          if (isLastElement) {
            poslednjiRed = row;
            // row.setAttribute("border", "none");
          }

          tblBody.appendChild(row);
        });

        tbl.setAttribute("border", "thin solid");
        tbl.style.borderCollapse = "collapse";
        // tbl.style.borderColor = "black";

        tbl.appendChild(tblBody);

        tbl.style.margin = "0px 0px 0px 0px";
        tbl.style.width = "100%";

        elementToPrint.appendChild(tbl);

        var tbl = document.createElement("table");
        var tblBody = document.createElement("tbody");

        tbl.style.margin = "20px 0px 0px 75%";
        tbl.style.width = "25%";
        // tbl.setAttribute("border", "thin solid");
        tbl.style.borderCollapse = "collapse";
        tbl.appendChild(tblBody);
        elementToPrint.appendChild(tbl);

        // tblBody.appendChild(poslednjiRed);

        // tbl.appendChild(tblBody);
        // elementToPrint.appendChild(tbl);

        // html2pdf(elementToPrint, {
        //   margin: 1,
        //   filename: item.number + ".pdf",
        //   image: { type: "jpeg", quality: 0.98 },
        //   // html2canvas: { dpi: 192, letterRendering: true },
        //   html2canvas: { dpi: 300, scale: 2 },
        //   jsPDF: { unit: "cm", format: "a4", orientation: "portrait" },
        // }).then((response) => {
        //   this.isLoading = false;
        // });

        html2pdf(null, {
          margin: 1,
          // filename: item.number + ".pdf",
          image: { type: "jpeg", quality: 0.98 },
          html2canvas: { dpi: 300, scale: 2 },
          jsPDF: { unit: "cm", format: "a4", orientation: "landscape" },
          // pagebreak: {
          //     mode: ['avoid-all', 'css', 'legacy']
          // }
          pagebreak: { avoid: ["tr", "td"], before: "#nextpage1" },
        })
          .from(elementToPrint)
          .toPdf()
          .get("pdf")
          .then(function (pdf) {
            var totalPages = pdf.internal.getNumberOfPages();
            var i;

            for (i = 1; i <= totalPages; i++) {
              pdf.setPage(i);
              pdf.setFontSize(10);
              pdf.setTextColor(150);

              pdf.text(
                getDateTime(),
                0.9,
                pdf.internal.pageSize.getHeight() - 0.5
              );

              pdf.text(
                i + " od " + totalPages,
                pdf.internal.pageSize.getWidth() / 1.075,
                pdf.internal.pageSize.getHeight() - 0.5
              );
            }
            _this.isLoading = false;

            window.open(pdf.output("bloburl"), "_blank");
          });
      }, 10);
    },
    stampajMerenja() {
      let _this = this;
      this.isLoading = true;

      this.naziv_fajla = "merenja.xls";

      if (this.tip_tanka === 15) {
        if (this.selectedTabMerenja === 0)
          this.naslov = "Merenja za šaržu " + this.items.tank.name;
        else
          this.naslov =
            "Prethodna merenja za vino iz šarže " + this.items.tank.name;

        this.json_fields = {
          Rb: "String",
          Datum: "Date",
          Barik: "String",
          Parametar: "String",
          Količina: "Number",
          Tank: "String",
          Faza: "String",
          Vino: "String",
          "Količina vina": "Number",
        };

        this.json_fields_type = [
          "String",
          "Date",
          "String",
          "String",
          "Number",
          "String",
          "String",
          "String",
          "Number",
        ];
      } else {
        if (this.selectedTabMerenja === 0)
          this.naslov = "Merenja za tank " + this.items.tank.name;
        else
          this.naslov =
            "Prethodna merenja za vino iz tanka " + this.items.tank.name;

        this.json_fields = {
          Rb: "String",
          Datum: "Date",
          Parametar: "String",
          Količina: "Number",
          Tank: "String",
          Faza: "String",
          Vino: "String",
          "Količina vina": "Number",
        };

        this.json_fields_type = [
          "String",
          "Date",
          "String",
          "Number",
          "String",
          "String",
          "String",
          "Number",
        ];
      }

      this.json_data = [];
      let rbr = 1;

      this.items_merenja.forEach(function (entry) {
        let objekat;

        if (_this.tip_tanka === 15) {
          let spisakBarika = "";

          if (entry.tankFromBatchInOperations.length > 0)
            entry.tankFromBatchInOperations.forEach(function (e) {
              if (spisakBarika !== "")
                spisakBarika =
                  spisakBarika + ", " + e.tank.batchPrefix + "|" + e.tank.name;
              else spisakBarika = e.tank.batchPrefix + "|" + e.tank.name;
            });
          else spisakBarika = "Svi barici";

          objekat = {
            Rb: rbr,
            Datum: _this.formatDateTime(entry.date),
            Barik: spisakBarika,
            Parametar: entry.name,
            Količina: entry.quantity + " " + entry.unitOfMeasure,
            Tank: entry.tankName,
            Faza: entry.phaseAtMoment,
            Vino: entry.wineAtMoment,
            "Količina vina":
              entry.wineQuantityAtMoment +
              " " +
              entry.wineQuantityAtMomentUnitOfMeasure,
          };
        } else
          objekat = {
            Rb: rbr,
            Datum: _this.formatDateTime(entry.date),
            Parametar: entry.name,
            Količina: entry.quantity + " " + entry.unitOfMeasure,
            Tank: entry.tankName,
            Faza: entry.phaseAtMoment,
            Vino: entry.wineAtMoment,
            "Količina vina":
              entry.wineQuantityAtMoment +
              " " +
              entry.wineQuantityAtMomentUnitOfMeasure,
          };

        _this.json_data.push(objekat);

        rbr = rbr + 1;
      });

      setTimeout(() => {
        var elementToPrint = document.createElement("div");
        elementToPrint.style.margin = "0px 0px 0px 0px";

        var elementToPrint2 = document.createElement("p");
        elementToPrint2.innerHTML = _this.naslov;

        elementToPrint2.style.position = "relative";
        elementToPrint2.style.textAlign = "center";
        elementToPrint2.style.fontSize = "20px";
        elementToPrint.append(elementToPrint2);

        // var body = document.getElementsByTagName("body")[0];
        var tbl = document.createElement("table");
        var tr = document.createElement("tr"); // Header row
        jQuery.each(_this.json_fields, function (i, val) {
          var th = document.createElement("th"); //column
          var text = "";
          text = document.createTextNode(i);

          th.setAttribute("style", "padding-bottom: 4px;");

          th.appendChild(text);

          tr.appendChild(th);
        });

        tr.style.background = "#eaece5";
        tbl.appendChild(tr);

        var tblBody = document.createElement("tbody");

        let poslednjiRed = null;

        jQuery.each(_this.json_data, function (i, val1) {
          var isLastElement = i == _this.json_data.length - 1;

          var row = document.createElement("tr");

          let pomJ = 0;

          jQuery.each(val1, function (i, val) {
            var cell = document.createElement("td");

            var cellText;

            if (val === null || val === 0 || val === "")
              cellText = document.createTextNode("-");
            else cellText = document.createTextNode(val);

            cell.appendChild(cellText);

            if (i === 1)
              cell.setAttribute(
                "style",
                "text-align :left; padding-left: 5px; padding-bottom: 4px;"
              );
            else if (
              _this.json_fields_type[pomJ] === "Number" ||
              _this.json_fields_type[pomJ] === "StringRight"
            ) {
              cell.setAttribute(
                "style",
                "text-align :right; padding-bottom: 4px; padding-right: 5px;"
              );
            } else if (_this.json_fields_type[pomJ] === "Date") {
              cell.setAttribute(
                "style",
                "text-align :center; padding-bottom: 4px; padding-right: 1px; padding-left: 1px;"
              );
            } else
              cell.setAttribute(
                "style",
                "text-align :center; padding-bottom: 4px;"
              );

            pomJ = pomJ + 1;

            row.appendChild(cell);
          });

          if (isLastElement) {
            poslednjiRed = row;
            // row.setAttribute("border", "none");
          }

          tblBody.appendChild(row);
        });

        tbl.setAttribute("border", "thin solid");
        tbl.style.borderCollapse = "collapse";
        // tbl.style.borderColor = "black";

        tbl.appendChild(tblBody);

        tbl.style.margin = "0px 0px 0px 0px";
        tbl.style.width = "100%";

        elementToPrint.appendChild(tbl);

        var tbl = document.createElement("table");
        var tblBody = document.createElement("tbody");

        tbl.style.margin = "20px 0px 0px 75%";
        tbl.style.width = "25%";
        // tbl.setAttribute("border", "thin solid");
        tbl.style.borderCollapse = "collapse";
        tbl.appendChild(tblBody);
        elementToPrint.appendChild(tbl);

        // tblBody.appendChild(poslednjiRed);

        // tbl.appendChild(tblBody);
        // elementToPrint.appendChild(tbl);

        // html2pdf(elementToPrint, {
        //   margin: 1,
        //   filename: item.number + ".pdf",
        //   image: { type: "jpeg", quality: 0.98 },
        //   // html2canvas: { dpi: 192, letterRendering: true },
        //   html2canvas: { dpi: 300, scale: 2 },
        //   jsPDF: { unit: "cm", format: "a4", orientation: "portrait" },
        // }).then((response) => {
        //   this.isLoading = false;
        // });

        html2pdf(null, {
          margin: 1,
          // filename: item.number + ".pdf",
          image: { type: "jpeg", quality: 0.98 },
          html2canvas: { dpi: 300, scale: 2 },
          jsPDF: { unit: "cm", format: "a4", orientation: "landscape" },
          // pagebreak: {
          //     mode: ['avoid-all', 'css', 'legacy']
          // }
          pagebreak: { avoid: ["tr", "td"], before: "#nextpage1" },
        })
          .from(elementToPrint)
          .toPdf()
          .get("pdf")
          .then(function (pdf) {
            var totalPages = pdf.internal.getNumberOfPages();
            var i;

            for (i = 1; i <= totalPages; i++) {
              pdf.setPage(i);
              pdf.setFontSize(10);
              pdf.setTextColor(150);

              pdf.text(
                getDateTime(),
                0.9,
                pdf.internal.pageSize.getHeight() - 0.5
              );

              pdf.text(
                i + " od " + totalPages,
                pdf.internal.pageSize.getWidth() / 1.075,
                pdf.internal.pageSize.getHeight() - 0.5
              );
            }
            _this.isLoading = false;

            window.open(pdf.output("bloburl"), "_blank");
          });
      }, 10);
    },
    // doSomethingDodaci(n) {
    //   if (n === 0) this.items_dodaci = this.items_dodaci_init;
    //   else this.items_dodaci = this.items_dodaci_prev;
    // },
    // doSomethingMerenja(n) {
    //   if (n === 0) this.items_merenja = this.items_merenja_init;
    //   else this.items_merenja = this.items_merenja_prev;
    // },
    doSomething(n) {
      this.items_inputoutput = [];

      if (this.selectedTab === 0) {
        if (this.tip_tanka_naziv === "press") {
          this.headers_inputoutput = [
            { text: "" },
            { text: "Datum", value: "date", align: "center" },
            { text: "Faza", value: "phaseAtMoment", align: "center" },
            { text: "Vino", value: "wineAtMoment", align: "center" },
            { text: "Operacija", value: "operation", align: "center" },
            { text: "Iz tanka", value: "tankName", align: "center" },
            { text: "U tank", value: "tankName", align: "left" },
            { text: "Količina", value: "quantity", align: "left" },
            { text: "Komina", value: "sediment", align: "left" },
            { text: "Rastur", value: "outage", align: "left" },
            { text: "Opis", value: "description", align: "left" },
          ];
        } else {
          this.headers_inputoutput = [
            { text: "" },
            { text: "Datum", value: "date", align: "center" },
            { text: "Faza", value: "phaseAtMoment", align: "center" },
            { text: "Vino", value: "wineAtMoment", align: "center" },
            { text: "Operacija", value: "operation", align: "center" },
            { text: "Iz tanka", value: "tankName", align: "center" },
            { text: "U tank", value: "tankName", align: "left" },
            { text: "Količina", value: "quantity", align: "left" },
            { text: "Talog", value: "sediment", align: "left" },
            { text: "Rastur", value: "outage", align: "left" },
            { text: "Opis", value: "description", align: "left" },
          ];
        }
      } else if (this.selectedTab === 2) {
        if (this.tip_tanka_naziv === "press") {
          this.headers_inputoutput = [
            { text: "" },
            { text: "Datum", value: "date", align: "center" },
            { text: "Faza", value: "phaseAtMoment", align: "center" },
            { text: "Vino", value: "wineAtMoment", align: "center" },
            { text: "Operacija", value: "operation", align: "center" },
            { text: "U tank", value: "tankName", align: "left" },
            { text: "Količina", value: "quantity", align: "left" },
            { text: "Komina", value: "sediment", align: "left" },
            { text: "Rastur", value: "outage", align: "left" },
            { text: "Opis", value: "description", align: "left" },
          ];
        } else {
          this.headers_inputoutput = [
            { text: "" },
            { text: "Datum", value: "date", align: "center" },
            { text: "Faza", value: "phaseAtMoment", align: "center" },
            { text: "Vino", value: "wineAtMoment", align: "center" },
            { text: "Operacija", value: "operation", align: "center" },
            { text: "U tank", value: "tankName", align: "left" },
            { text: "Količina", value: "quantity", align: "left" },
            { text: "Talog", value: "sediment", align: "left" },
            { text: "Rastur", value: "outage", align: "left" },
            { text: "Opis", value: "description", align: "left" },
          ];
        }
      } else if (this.selectedTab === 1) {
        if (this.tip_tanka_naziv === "press") {
          this.headers_inputoutput = [
            { text: "" },
            { text: "Datum", value: "date", align: "center" },
            { text: "Faza", value: "phaseAtMoment", align: "center" },
            { text: "Vino", value: "wineAtMoment", align: "center" },
            { text: "Operacija", value: "operation", align: "center" },
            { text: "Iz tanka", value: "tankName", align: "center" },
            { text: "Količina", value: "quantity", align: "left" },
            { text: "Komina", value: "sediment", align: "left" },
            { text: "Rastur", value: "outage", align: "left" },
            { text: "Opis", value: "description", align: "left" },
          ];
        } else {
          this.headers_inputoutput = [
            { text: "" },
            { text: "Datum", value: "date", align: "center" },
            { text: "Faza", value: "phaseAtMoment", align: "center" },
            { text: "Vino", value: "wineAtMoment", align: "center" },
            { text: "Operacija", value: "operation", align: "center" },
            { text: "Iz tanka", value: "tankName", align: "center" },
            { text: "Količina", value: "quantity", align: "left" },
            { text: "Talog", value: "sediment", align: "left" },
            { text: "Rastur", value: "outage", align: "left" },
            { text: "Opis", value: "description", align: "left" },
          ];
        }
      } else if (this.selectedTab === 3)
        this.headers_inputoutput = [
          { text: "" },
          { text: "Tank", value: "tankName", align: "center" },
          { text: "Grožđe", value: "grapeVariety", align: "center" },
          { text: "Vinograd", value: "vineyard", align: "center" },
          { text: "Berba", value: "harvestDate", align: "left" },
          { text: "Ulaz u tank", value: "entryDate", align: "left" },
          { text: "Udeo u vinu", value: "relativePart", align: "left" },
          { text: "Količina grožđa", value: "grapeQuantity", align: "left" },
          { text: "Kljuk/šira", value: "stumQuantity", align: "left" },
          { text: "Cena", value: "grapePrice", align: "left" },
          {
            text: "Temperatura grozđa",
            value: "grapeTemperature",
            align: "left",
          },
          { text: "Maceracija", value: "maceration", align: "left" },
          { text: "Opis", value: "description", align: "left" },
        ];

      // alert("n - " + n)

      if (n == 1) this.getAllInputOutput();
      else if (n == 2) this.getAllInput();
      else if (n == 3) this.getAllOutput();
      else if (n == 4) this.getGrapeInput();
    },
    formatDateTime(date) {
      if (typeof date !== "undefined" && date !== null) {
        let lokDate = date.split("T")[0];
        let lokTime = date.split("T")[1];

        let month = lokDate.split("-")[1];
        let day = lokDate.split("-")[2];
        const year = lokDate.split("-")[0];

        let HH = lokTime.split(":")[0];
        let mm = lokTime.split(":")[1];

        return [day, month, year].join(".") + " " + [HH, mm].join(":");
      } else return "";
    },
    formatDate(date) {
      if (typeof date !== "undefined" && date !== null) {
        let lokDate = date.split("T")[0];

        let month = lokDate.split("-")[1];
        let day = lokDate.split("-")[2];
        const year = lokDate.split("-")[0];

        return [day, month, year].join(".");
      } else return "";
    },
    formatTank_U(stringLok, nazivTanka) {
      let pomStr = "";

      if (stringLok == "OUT") pomStr = nazivTanka;
      else pomStr = "";
      return pomStr;
    },
    formatTank_IZ(stringLok, nazivTanka, item) {
      let pomStr = "";

      if (stringLok === "IN") pomStr = nazivTanka;
      else {
        if (item !== null) pomStr = this.formatImena(item);
      }
      return pomStr;
    },
    formatImena(item) {
      let returnText = "";

      if (
        item.tankFromBatchInOperations !== undefined &&
        item.tankFromBatchInOperations !== null
      )
        if (item.tankFromBatchInOperations.length === 0) returnText = "";
        else {
          if (
            item.tankFromBatchInOperations.length % 10 === 1 &&
            item.tankFromBatchInOperations.length !== 11
          )
            returnText = item.tankFromBatchInOperations.length + " barik";
          else returnText = item.tankFromBatchInOperations.length + " barika";
        }

      return returnText;
    },
    prevediOperacijeLok(stringLok, frakcija) {
      let pomStr = "";

      pomStr = prevediSveOperacije(stringLok);

      if (stringLok === "PRESSING" && frakcija !== null)
        pomStr = pomStr + " - " + frakcija;

      return pomStr;
    },
    changeSort(column) {
      if (column !== "funkcije")
        if (this.pagination.sortBy === column) {
          this.pagination.descending = !this.pagination.descending;
        } else {
          this.pagination.sortBy = column;
          this.pagination.descending = false;
        }
    },
    changeSortMerenja(column) {
      if (column !== "funkcije")
        if (this.paginationMerenja.sortBy === column) {
          this.paginationMerenja.descending =
            !this.paginationMerenja.descending;
        } else {
          this.paginationMerenja.sortBy = column;
          this.paginationMerenja.descending = false;
        }
    },
    changeSortDodaci(column) {
      if (column !== "funkcije")
        if (this.paginationDodaci.sortBy === column) {
          this.paginationDodaci.descending = !this.paginationDodaci.descending;
        } else {
          this.paginationDodaci.sortBy = column;
          this.paginationDodaci.descending = false;
        }
    },
    getAllSifarnik2() {
      // console.log(this.tank_phase_vineId);
      let _this = this;

      this.$http
        .get(
          this.globalServiceLocation +
            this.globalPort +
            "/tank/tanks_in_batch/" +
            this.tankId,
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: "Bearer  " + localStorage.getItem("user-token"),
            },
          }
        )
        .then((response) => {
          let pomArray = response.data.sort(function (x, y) {
            return x.empty === y.empty ? 0 : x.empty ? 1 : -1;
          });

          _this.items_modal_izabrani_tankovi = pomArray;
        })
        .catch((e) => {
          if (!e.response) {
            alert(
              this.$t("error.message")
            );
          } else {
            if (e.response.status === 401) {
              this.$refs.frmtoken
                .osvezavanjeTokena(localStorage.getItem("user-refresh-token"))
                .then((result) => {
                  // // console.log(result);
                  // // console.log("Novi token - " + localStorage.getItem("user-token"));

                  this.$http
                    .get(
                      this.globalServiceLocation +
                        this.globalPort +
                        "/tank/tanks_in_batch/" +
                        this.tankId,
                      {
                        headers: {
                          "Content-Type": "application/json",
                          Authorization:
                            "Bearer  " + localStorage.getItem("user-token"),
                        },
                      }
                    )
                    .then((response) => {
                      let pomArray = response.data.sort(function (x, y) {
                        return x.empty === y.empty ? 0 : x.empty ? 1 : -1;
                      });

                      _this.items_modal_izabrani_tankovi = pomArray;
                    })
                    .catch((e) => {
                      // // console.log(e.response);

                      let pomError = readJSON(e.response.data.message);
                      alert(pomError);
                    });
                });
            } else {
              let pomError = readJSON(e.response.data.message);
              alert(pomError);
            }
          }
        });
    },
    getAllSifarnikBarika() {
      // console.log(this.tank_phase_vineId);

      this.$http
        .get(
          this.globalServiceLocation +
            this.globalPort +
            "/tank/tanks_in_batch/" +
            this.tankId +
            "/full?tpwId=" +
            this.tank_phase_vineId,
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: "Bearer  " + localStorage.getItem("user-token"),
            },
          }
        )
        .then((response) => {
          // this.selected_izabrani_tankovi = response.data;
          this.broj_barika = response.data;

          if (this.items.tank.piece !== undefined)
            if (
              this.items.tank.piece % 10 === 1 &&
              this.items.tank.piece !== 11
            )
              this.title_broj_barika =
                "Trenutno je punih " +
                this.broj_barika +
                " od ukupno " +
                this.items.tank.piece +
                " barik u šarzi.";
            else
              this.title_broj_barika =
                "Trenutno je punih " +
                this.broj_barika +
                " od ukupno " +
                this.items.tank.piece +
                " barika u šarzi.";

          console.log(response.data);
        })
        .catch((e) => {
          if (!e.response) {
            alert(
              this.$t("error.message")
            );
          } else {
            if (e.response.status === 401) {
              this.$refs.frmtoken
                .osvezavanjeTokena(localStorage.getItem("user-refresh-token"))
                .then((result) => {
                  // // console.log(result);
                  // // console.log("Novi token - " + localStorage.getItem("user-token"));

                  this.$http
                    .get(
                      this.globalServiceLocation +
                        this.globalPort +
                        "/tank/tanks_in_batch/" +
                        this.tankId +
                        "/full?tpwId=" +
                        this.tank_phase_vineId,
                      {
                        headers: {
                          "Content-Type": "application/json",
                          Authorization:
                            "Bearer  " + localStorage.getItem("user-token"),
                        },
                      }
                    )
                    .then((response) => {
                      // this.selected_izabrani_tankovi = response.data;
                      this.broj_barika = response.data;
                    })
                    .catch((e) => {
                      // // console.log(e.response);

                      let pomError = readJSON(e.response.data.message);
                      alert(pomError);
                    });
                });
            } else {
              let pomError = readJSON(e.response.data.message);
              alert(pomError);
            }
          }
        });
    },
    closeModalInModal_izabrani_tankovi() {
      this.selected_izabrani_tankovi = [];
      this.items_modal_izabrani_tankovi = [];

      this.dialogNote_izabrani_tankovi = false;

      this.pagination.sortBy = undefined;
    },
    otvoriModal_izabrani_tankovi() {
      this.dialogNote_izabrani_tankovi = true;
      this.getAllSifarnik2();
    },
    getAllSifarnik() {
      this.$http
        .get(
          this.globalServiceLocation +
            this.globalPort +
            "/tank_phase_wine/" +
            this.tank_phase_vineId,
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: "Bearer  " + localStorage.getItem("user-token"),
            },
          }
        )
        .then((response) => {
          this.tip_tanka = response.data.tank.tankType.id;
          this.tip_tanka_naziv = response.data.tank.tankType.enumLable;

          if (this.tip_tanka === 15) {
            this.headers_merenja = this.headers_merenja_sarza;
            this.headers_dodaci = this.headers_dodaci_sarza;
          } else {
            this.headers_merenja = this.headers_merenja_init;
            this.headers_dodaci = this.headers_dodaci_init;
          }

          this.getAllTemperature();
          this.getAllLastSugerTemperature();
          this.getAllLastComment();

          this.getAllMerenja(true);
          this.getAllDodaci(true);

          // this.getAllInputOutput();
          this.doSomething(this.selectedTab + 1);

          this.getAllGrafici();

          this.prazan_tank = response.data.quantity;

          debugger

          this.items = response.data;

          this.naslovIzvestaja = this.items.wine.wineLabel.name + " " + 	this.items.wine.year + " iz " + this.items.tank.name;

          if (this.broj_barika !== "")
            if (
              this.items.tank.piece % 10 === 1 &&
              this.items.tank.piece !== 11
            )
              this.title_broj_barika =
                "Trenutno je punih " +
                this.broj_barika +
                " od ukupno " +
                this.items.tank.piece +
                " barik u šarzi.";
            else
              this.title_broj_barika =
                "Trenutno je punih " +
                this.broj_barika +
                " od ukupno " +
                this.items.tank.piece +
                " barika u šarzi.";

          this.wineId = response.data.wine.id;

          // console.log(this.items);

          this.phaseMark = response.data.phase.phaseMark;

          if (response.data.phase !== null) {
            let flasiranje;

            if (response.data.phase.bottling) flasiranje = false;
            else flasiranje = true;

            let ulaz_grozdja;

            if (response.data.phase.grapeInput) ulaz_grozdja = false;
            else ulaz_grozdja = true;

            let presovanje;

            if (response.data.tank.tankType.name.indexOf("presa") >= 0)
              presovanje = false;
            else presovanje = true;

            if (response.data.phase.phaseMark === "AF") {
              this.disabled_phase = false;

              let nizVrednosti = [
                ulaz_grozdja,
                ulaz_grozdja,
                !presovanje,
                false,
                false,
                false,
                false,
                flasiranje,
                false,
                false,
                false,
                response.data.active ? true : false,
              ];
              serverBus.$emit("disable_action", nizVrednosti);
            } else if (response.data.phase.phaseMark === "MF") {
              this.disabled_phase = false;

              let nizVrednosti = [
                ulaz_grozdja,
                ulaz_grozdja,
                !presovanje,
                false,
                false,
                false,
                false,
                flasiranje,
                false,
                false,
                false,
                response.data.active ? true : false,
              ];
              serverBus.$emit("disable_action", nizVrednosti);
            } else if (response.data.phase.phaseMark === "AM") {
              this.disabled_phase = false;

              let nizVrednosti = [
                ulaz_grozdja,
                ulaz_grozdja,
                !presovanje,
                false,
                false,
                false,
                false,
                flasiranje,
                false,
                false,
                false,
                response.data.active ? true : false,
              ];
              serverBus.$emit("disable_action", nizVrednosti);
            } else if (response.data.phase.phaseMark === "OD") {
              this.disabled_phase = false;

              let nizVrednosti = [
                ulaz_grozdja,
                ulaz_grozdja,
                !presovanje,
                false,
                false,
                false,
                false,
                flasiranje,
                false,
                false,
                false,
                response.data.active ? true : false,
              ];
              serverBus.$emit("disable_action", nizVrednosti);
            } else {
              this.disabled_phase = false;

              let nizVrednosti = [
                ulaz_grozdja,
                ulaz_grozdja,
                !presovanje,
                false,
                false,
                false,
                false,
                flasiranje,
                false,
                false,
                false,
                response.data.active ? true : false,
              ];
              serverBus.$emit("disable_action", nizVrednosti);
            }
          } else {
            this.disabled_phase = false;

            let nizVrednosti = [
              false,
              false,
              true,
              false,
              true,
              true,
              true,
              true,
              true,
              true,
              true,
              false,
            ];
            serverBus.$emit("disable_action", nizVrednosti);
          }

          // this.doSomething(this.selectedTab + 1);
        })
        .catch((e) => {
          if (!e.response) {
            alert(
              this.$t("error.message")
            );
          } else {
            if (e.response.status === 401) {
              this.$refs.frmtoken
                .osvezavanjeTokena(localStorage.getItem("user-refresh-token"))
                .then((result) => {
                  // // console.log(result);
                  // // console.log("Novi token - " + localStorage.getItem("user-token"));

                  this.$http
                    .get(
                      this.globalServiceLocation +
                        this.globalPort +
                        "/tank_phase_wine/" +
                        this.tank_phase_vineId,
                      {
                        headers: {
                          "Content-Type": "application/json",
                          Authorization:
                            "Bearer  " + localStorage.getItem("user-token"),
                        },
                      }
                    )
                    .then((response) => {
                      this.tip_tanka = response.data.tank.tankType.id;
                      this.tip_tanka_naziv =
                        response.data.tank.tankType.enumLable;

                      if (this.tip_tanka === 15) {
                        this.headers_merenja = this.headers_merenja_sarza;
                        this.headers_dodaci = this.headers_dodaci_sarza;
                      } else {
                        this.headers_merenja = this.headers_merenja_init;
                        this.headers_dodaci = this.headers_dodaci_init;
                      }

                      this.getAllTemperature();
                      this.getAllLastSugerTemperature();
                      this.getAllLastComment();

                      this.getAllMerenja(true);
                      this.getAllDodaci(true);

                      // this.getAllInputOutput();
                      this.doSomething(this.selectedTab + 1);

                      this.getAllGrafici();

                      this.prazan_tank = response.data.quantity;

                      this.items = response.data;

                      this.naslovIzvestaja = this.items.wine.wineLabel.name + " " + 	this.items.wine.year + " iz " + this.items.tank.name;

                      if (this.broj_barika !== "")
                        if (
                          this.items.tank.piece % 10 === 1 &&
                          this.items.tank.piece !== 11
                        )
                          this.title_broj_barika =
                            "Trenutno je punih " +
                            this.broj_barika +
                            " od ukupno " +
                            this.items.tank.piece +
                            " barik u šarzi.";
                        else
                          this.title_broj_barika =
                            "Trenutno je punih " +
                            this.broj_barika +
                            " od ukupno " +
                            this.items.tank.piece +
                            " barika u šarzi.";

                      this.wineId = response.data.wine.id;

                      // console.log(this.items);

                      this.phaseMark = response.data.phase.phaseMark;

                      if (response.data.phase !== null) {
                        let flasiranje;

                        if (response.data.phase.bottling) flasiranje = false;
                        else flasiranje = true;

                        let ulaz_grozdja;

                        if (response.data.phase.grapeInput)
                          ulaz_grozdja = false;
                        else ulaz_grozdja = true;

                        let presovanje;

                        if (
                          response.data.tank.tankType.name.indexOf("presa") >= 0
                        )
                          presovanje = false;
                        else presovanje = true;

                        if (response.data.phase.phaseMark === "AF") {
                          this.disabled_phase = false;

                          let nizVrednosti = [
                            ulaz_grozdja,
                            ulaz_grozdja,
                            !presovanje,
                            false,
                            false,
                            false,
                            false,
                            flasiranje,
                            false,
                            false,
                            false,
                            response.data.active ? true : false,
                          ];
                          serverBus.$emit("disable_action", nizVrednosti);
                        } else if (response.data.phase.phaseMark === "MF") {
                          this.disabled_phase = false;

                          let nizVrednosti = [
                            ulaz_grozdja,
                            ulaz_grozdja,
                            !presovanje,
                            false,
                            false,
                            false,
                            false,
                            flasiranje,
                            false,
                            false,
                            false,
                            response.data.active ? true : false,
                          ];
                          serverBus.$emit("disable_action", nizVrednosti);
                        } else if (response.data.phase.phaseMark === "AM") {
                          this.disabled_phase = false;

                          let nizVrednosti = [
                            ulaz_grozdja,
                            ulaz_grozdja,
                            !presovanje,
                            false,
                            false,
                            false,
                            false,
                            flasiranje,
                            false,
                            false,
                            false,
                            response.data.active ? true : false,
                          ];
                          serverBus.$emit("disable_action", nizVrednosti);
                        } else if (response.data.phase.phaseMark === "OD") {
                          this.disabled_phase = false;

                          let nizVrednosti = [
                            ulaz_grozdja,
                            ulaz_grozdja,
                            !presovanje,
                            false,
                            false,
                            false,
                            false,
                            flasiranje,
                            false,
                            false,
                            false,
                            response.data.active ? true : false,
                          ];
                          serverBus.$emit("disable_action", nizVrednosti);
                        } else {
                          this.disabled_phase = false;

                          let nizVrednosti = [
                            ulaz_grozdja,
                            ulaz_grozdja,
                            !presovanje,
                            false,
                            false,
                            false,
                            false,
                            flasiranje,
                            false,
                            false,
                            false,
                            response.data.active ? true : false,
                          ];
                          serverBus.$emit("disable_action", nizVrednosti);
                        }
                      } else {
                        this.disabled_phase = false;

                        let nizVrednosti = [
                          false,
                          false,
                          true,
                          false,
                          true,
                          true,
                          true,
                          true,
                          true,
                          true,
                          true,
                          false,
                        ];
                        serverBus.$emit("disable_action", nizVrednosti);
                      }
                    })
                    .catch((e) => {
                      // // console.log(321);

                      // // console.log(e.response);

                      let pomError = readJSON(e.response.data.message);
                      alert(pomError);
                    });
                });
            } else {
              let pomError = readJSON(e.response.data.message);
              alert(pomError);
            }
          }
        });
    },
    getAllMerenja(isCurrentTank) {
      if(!isCurrentTank)
        this.isLoading = true;

      this.$http
        .get(
          this.globalServiceLocation +
            this.globalPort +
            "/measurement/table/" +
            this.tank_phase_vineId + "/" + isCurrentTank,
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: "Bearer  " + localStorage.getItem("user-token"),
            },
          }
        )
        .then((response) => {
          // // console.log("merenja - " + this.tank_phase_vineId);
          // console.log(response.data);

          this.items_merenja = response.data;
          
          if(!isCurrentTank)
            this.isLoading = false;
        })
        .catch((e) => {
          if(!isCurrentTank)
            this.isLoading = false;

          let pomError = readJSON(e.response.data.message);
          alert(pomError);
        });
    },
    getAllInputOutput() {
      this.$http
        .get(
          this.globalServiceLocation +
            this.globalPort +
            "/tank_phase_wine/" +
            this.tank_phase_vineId +
            "/input_output",
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: "Bearer  " + localStorage.getItem("user-token"),
            },
          }
        )
        .then((response) => {
          console.log(response.data);
          this.items_inputoutput = response.data;
        })
        .catch((e) => {
          // // console.log(e.response);

          let pomError = readJSON(e.response.data.message);
          alert(pomError);
        });
    },
    getAllInput() {
      this.$http
        .get(
          this.globalServiceLocation +
            this.globalPort +
            "/tank_phase_wine/" +
            this.tank_phase_vineId +
            "/input",
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: "Bearer  " + localStorage.getItem("user-token"),
            },
          }
        )
        .then((response) => {
          this.items_inputoutput = response.data;
        })
        .catch((e) => {
          if (!e.response) {
            alert(
              this.$t("error.message")
            );
          } else {
            if (e.response.status === 401) {
              this.$refs.frmtoken
                .osvezavanjeTokena(localStorage.getItem("user-refresh-token"))
                .then((result) => {
                  // // console.log(result);
                  // // console.log("Novi token - " + localStorage.getItem("user-token"));

                  this.$http
                    .get(
                      this.globalServiceLocation +
                        this.globalPort +
                        "/tank_phase_wine/" +
                        this.tank_phase_vineId +
                        "/input",
                      {
                        headers: {
                          "Content-Type": "application/json",
                          Authorization:
                            "Bearer  " + localStorage.getItem("user-token"),
                        },
                      }
                    )
                    .then((response) => {
                      this.items_inputoutput = response.data;
                    })
                    .catch((e) => {
                      // // console.log(e.response);

                      let pomError = readJSON(e.response.data.message);
                      alert(pomError);
                    });
                });
            } else {
              let pomError = readJSON(e.response.data.message);
              alert(pomError);
            }
          }
        });
    },
    getAllOutput() {
      this.$http
        .get(
          this.globalServiceLocation +
            this.globalPort +
            "/tank_phase_wine/" +
            this.tank_phase_vineId +
            "/output",
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: "Bearer  " + localStorage.getItem("user-token"),
            },
          }
        )
        .then((response) => {
          this.items_inputoutput = response.data;
        })
        .catch((e) => {
          if (!e.response) {
            alert(
              this.$t("error.message")
            );
          } else {
            if (e.response.status === 401) {
              this.$refs.frmtoken
                .osvezavanjeTokena(localStorage.getItem("user-refresh-token"))
                .then((result) => {
                  // // console.log(result);
                  // // console.log("Novi token - " + localStorage.getItem("user-token"));

                  this.$http
                    .get(
                      this.globalServiceLocation +
                        this.globalPort +
                        "/tank_phase_wine/" +
                        this.tank_phase_vineId +
                        "/output",
                      {
                        headers: {
                          "Content-Type": "application/json",
                          Authorization:
                            "Bearer  " + localStorage.getItem("user-token"),
                        },
                      }
                    )
                    .then((response) => {
                      this.items_inputoutput = response.data;
                    })
                    .catch((e) => {
                      // // console.log(e.response);

                      let pomError = readJSON(e.response.data.message);
                      alert(pomError);
                    });
                });
            } else {
              let pomError = readJSON(e.response.data.message);
              alert(pomError);
            }
          }
        });
    },
    getGrapeInput() {
      this.$http
        .get(
          this.globalServiceLocation +
            this.globalPort +
            "/tank_phase_wine/" +
            this.tank_phase_vineId +
            "/grape_input",
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: "Bearer  " + localStorage.getItem("user-token"),
            },
          }
        )
        .then((response) => {
          // alert(this.tank_phase_vineId)
          // console.log(response.data);

          this.items_inputoutput = response.data;
        })
        .catch((e) => {
          if (!e.response) {
            alert(
              this.$t("error.message")
            );
          } else {
            if (e.response.status === 401) {
              this.$refs.frmtoken
                .osvezavanjeTokena(localStorage.getItem("user-refresh-token"))
                .then((result) => {
                  // // console.log(result);
                  // // console.log("Novi token - " + localStorage.getItem("user-token"));

                  this.$http
                    .get(
                      this.globalServiceLocation +
                        this.globalPort +
                        "/tank_phase_wine/" +
                        this.tank_phase_vineId +
                        "/grape_input",
                      {
                        headers: {
                          "Content-Type": "application/json",
                          Authorization:
                            "Bearer  " + localStorage.getItem("user-token"),
                        },
                      }
                    )
                    .then((response) => {
                      this.items_inputoutput = response.data;
                    })
                    .catch((e) => {
                      // // console.log(e.response);

                      let pomError = readJSON(e.response.data.message);
                      alert(pomError);
                    });
                });
            } else {
              let pomError = readJSON(e.response.data.message);
              alert(pomError);
            }
          }
        });
    },
    getAllTemperature() {
      this.$http
        .get(
          this.globalServiceLocation +
            this.globalPort +
            "/desired_parameter_value/tank_phase_wine/" +
            this.tank_phase_vineId +
            "/temperatures",
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: "Bearer  " + localStorage.getItem("user-token"),
            },
          }
        )
        .then((response) => {
          if (response.data[1] === null) this.zeljena_temperatura = "-";
          else this.zeljena_temperatura = response.data[1];

          if (response.data[0] === null) this.trenutna_temperatura = "-";
          else this.trenutna_temperatura = response.data[0];
        })
        .catch((e) => {
          // // console.log(e.response);

          let pomError = readJSON(e.response.data.message);
          alert(pomError);
        });
    },
    getAllLastSugerTemperature() {
      this.$http
        .get(
          this.globalServiceLocation +
            this.globalPort +
            "/measurement/sugar_and_temperature/" +
            this.tank_phase_vineId +
            "/last",
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: "Bearer  " + localStorage.getItem("user-token"),
            },
          }
        )
        .then((response) => {
          if (response.data[0] === null) this.trenutno_secera = "-";
          else this.trenutno_secera = response.data[0];

          if (response.data[1] === null) this.poslednja_temperatura = "-";
          else this.poslednja_temperatura = response.data[1];
        })
        .catch((e) => {
          // // console.log(e.response);

          let pomError = readJSON(e.response.data.message);
          alert(pomError);
        });
    },
    getAllLastComment() {
      this.$http
        .get(
          this.globalServiceLocation +
            this.globalPort +
            "/comment/tank_phase_wine/" +
            this.tank_phase_vineId +
            "/last",
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: "Bearer  " + localStorage.getItem("user-token"),
            },
          }
        )
        .then((response) => {
          if (response.data === null) this.poslednji_komentar = "-";
          else this.poslednji_komentar = response.data.comment;
        })
        .catch((e) => {
          // // console.log(e.response);

          let pomError = readJSON(e.response.data.message);
          alert(pomError);
        });
    },
    getGrapeVarietyParts() {
      this.$http
        .get(
          this.globalServiceLocation +
            this.globalPort +
            "/tank_phase_wine/" +
            this.tank_phase_vineId +
            "/grape_variety_parts",
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: "Bearer  " + localStorage.getItem("user-token"),
            },
          }
        )
        .then((response) => {
          console.log(response.data);

          this.data_grape_variety_parts = response.data;

          this.ucitajGrafik();
        })
        .catch((e) => {
          if (!e.response) {
            alert(
              this.$t("error.message")
            );
          } else {
            if (e.response.status === 401) {
              this.$refs.frmtoken
                .osvezavanjeTokena(localStorage.getItem("user-refresh-token"))
                .then((result) => {
                  // // console.log(result);
                  // // console.log("Novi token - " + localStorage.getItem("user-token"));

                  this.$http
                    .get(
                      this.globalServiceLocation +
                        this.globalPort +
                        "/tank_phase_wine/" +
                        this.tank_phase_vineId +
                        "/grape_variety_parts",
                      {
                        headers: {
                          "Content-Type": "application/json",
                          Authorization:
                            "Bearer  " + localStorage.getItem("user-token"),
                        },
                      }
                    )
                    .then((response) => {
                      // // console.log(response.data);

                      this.data_grape_variety_parts = response.data;

                      this.ucitajGrafik();
                    })
                    .catch((e) => {
                      // // console.log(e.response);

                      let pomError = readJSON(e.response.data.message);
                      alert(pomError);
                    });
                });
            } else {
              let pomError = readJSON(e.response.data.message);
              alert(pomError);
            }
          }
        });
    },
    getAllVina() {
      this.$http
        .get(this.globalServiceLocation + this.globalPort + "/wine/all", {
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer  " + localStorage.getItem("user-token"),
          },
        })
        .then((response) => {
          // // console.log(response.data);

          this.wine_to_items = response.data;
        })
        .catch((e) => {
          if (!e.response) {
            alert(
              this.$t("error.message")
            );
          } else {
            if (e.response.status === 401) {
              this.$refs.frmtoken
                .osvezavanjeTokena(localStorage.getItem("user-refresh-token"))
                .then((result) => {
                  // // console.log(result);
                  // // console.log("Novi token - " + localStorage.getItem("user-token"));

                  this.$http
                    .get(
                      this.globalServiceLocation +
                        this.globalPort +
                        "/wine/all",
                      {
                        headers: {
                          "Content-Type": "application/json",
                          Authorization:
                            "Bearer  " + localStorage.getItem("user-token"),
                        },
                      }
                    )
                    .then((response) => {
                      // // console.log(response.data);

                      this.wine_to_items = response.data;
                    })
                    .catch((e) => {
                      // // console.log(e.response);

                      let pomError = readJSON(e.response.data.message);
                      alert(pomError);
                    });
                });
            } else {
              let pomError = readJSON(e.response.data.message);
              alert(pomError);
            }
          }
        });
    },
    getAllDodaci(isCurrentTank) {
      if(!isCurrentTank)
        this.isLoading = true;

      this.$http
        .get(
          this.globalServiceLocation +
            this.globalPort +
            "/add/table/" +
            this.tank_phase_vineId + "/" + isCurrentTank,
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: "Bearer  " + localStorage.getItem("user-token"),
            },
          }
        )
        .then((response) => {
          // // console.log("dodaci - " + this.tank_phase_vineId);
          // this.items_dodaci_init = [];
          // this.items_dodaci_prev = [];

          // let _this = this;

          // response.data.forEach(function (element) {
          //   if (_this.tank_phase_vineId === element.tankPhaseWineId)
          //     _this.items_dodaci_init.push(element);
          //   else _this.items_dodaci_prev.push(element);
          // });

          // _this.doSomethingDodaci(0);

          this.items_dodaci = response.data;

          if(!isCurrentTank)
            this.isLoading = false;
        })
        .catch((e) => {
          if(!isCurrentTank)
            this.isLoading = false;

          let pomError = readJSON(e.response.data.message);
          alert(pomError);
        });
    },
    getAllGrafici() {
      this.$http
        .get(
          this.globalServiceLocation +
            this.globalPort +
            "/measurement/sugar_and_temperature/" +
            this.tank_phase_vineId +
            "/history_tanks",
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: "Bearer  " + localStorage.getItem("user-token"),
            },
          }
        )
        .then((response) => {
          // // console.log("grafici - " + this.tank_phase_vineId);
          // // console.log(response.data);

          this.items_grafici = response.data;

          // this.items_grafici.sort(function(a,b){
          //     return a.tankPhaseWineId - a.tankPhaseWineId;
          // });

          // // console.log(this.items_grafici);
        })
        .catch((e) => {
          // // console.log(e.response);

          let pomError = readJSON(e.response.data.message);
          alert(pomError);
        });
    },
    izmeniFazu() {
      var pom_phase_to_select;

      if (typeof this.phase_to_select !== "undefined")
        if (this.phase_to_select.id == null)
          pom_phase_to_select = this.phase_to_select;
        else pom_phase_to_select = this.phase_to_select.id;

      let complexObject = {
        tankPhaseWineId: this.tank_phase_vineId,
        toPhaseId: pom_phase_to_select,
      };

      this.$http
        .put(
          this.globalServiceLocation +
            this.globalPort +
            "/tank_phase_wine/update_phase",
          complexObject,
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: "Bearer  " + localStorage.getItem("user-token"),
            },
          }
        )
        .then((response) => {
          // // console.log(response.data);

          this.nextPhases(this.tankId);
          serverBus.$emit("ucitaj_podatke");
        })
        .catch((e) => {
          if (!e.response) {
            alert(
              this.$t("error.message")
            );
          } else {
            if (e.response.status === 401) {
              this.$refs.frmtoken
                .osvezavanjeTokena(localStorage.getItem("user-refresh-token"))
                .then((result) => {
                  // // console.log(result);
                  // // console.log("Novi token - " + localStorage.getItem("user-token"));

                  this.$http
                    .put(
                      this.globalServiceLocation +
                        this.globalPort +
                        "/tank_phase_wine/update_phase",
                      complexObject,
                      {
                        headers: {
                          "Content-Type": "application/json",
                          Authorization:
                            "Bearer  " + localStorage.getItem("user-token"),
                        },
                      }
                    )
                    .then((response) => {
                      // // console.log(response.data);

                      this.nextPhases(this.tankId);
                      serverBus.$emit("ucitaj_podatke");
                    })
                    .catch((e) => {
                      // // console.log(e.response);

                      let pomError = readJSON(e.response.data.message);
                      alert(pomError);
                    });
                });
            } else {
              let pomError = readJSON(e.response.data.message);
              alert(pomError);
            }
          }
        });
    },
    izmeniVino() {
      var pom_wine_to_select;

      if (typeof this.wine_to_select !== "undefined")
        if (this.wine_to_select.id == null)
          pom_wine_to_select = this.wine_to_select;
        else pom_wine_to_select = this.wine_to_select.id;

      let complexObject = {
        tankPhaseWineId: this.tank_phase_vineId,
        toWineId: pom_wine_to_select,
      };

      this.$http
        .put(
          this.globalServiceLocation +
            this.globalPort +
            "/tank_phase_wine/update_wine",
          complexObject,
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: "Bearer  " + localStorage.getItem("user-token"),
            },
          }
        )
        .then((response) => {
          // // console.log(response.data);

          this.wineId = pom_wine_to_select;

          serverBus.$emit("ucitaj_podatke");
        })
        .catch((e) => {
          if (!e.response) {
            alert(
              this.$t("error.message")
            );
          } else {
            if (e.response.status === 401) {
              this.$refs.frmtoken
                .osvezavanjeTokena(localStorage.getItem("user-refresh-token"))
                .then((result) => {
                  // // console.log(result);
                  // // console.log("Novi token - " + localStorage.getItem("user-token"));

                  this.$http
                    .put(
                      this.globalServiceLocation +
                        this.globalPort +
                        "/tank_phase_wine/update_wine",
                      complexObject,
                      {
                        headers: {
                          "Content-Type": "application/json",
                          Authorization:
                            "Bearer  " + localStorage.getItem("user-token"),
                        },
                      }
                    )
                    .then((response) => {
                      // // console.log(response.data);

                      this.wineId = pom_wine_to_select;

                      serverBus.$emit("ucitaj_podatke");
                    })
                    .catch((e) => {
                      // // console.log(e.response);

                      let pomError = readJSON(e.response.data.message);
                      alert(pomError);
                    });
                });
            } else {
              let pomError = readJSON(e.response.data.message);
              alert(pomError);
            }
          }
        });
    },
    submit() {
      if (this.prikazi_faze) {
        this.izmeniFazu();
        this.prikazi_faze = false;
      } else {
        this.phase_to_select = this.phaseId;
        this.prikazi_faze = true;
      }
    },
    close() {
      this.prikazi_faze = false;
    },
    submit_wine() {
      if (this.prikazi_vina) {
        this.izmeniVino();
        this.prikazi_vina = false;
      } else {
        this.wine_to_select = this.wineId;
        this.prikazi_vina = true;
      }
    },
    customMounted() {
      // alert(this.tankId);

      if (this.dialogNote) {
        serverBus.$emit(
          "refresh_setparametertank",
          this.tank_phase_vineId,
          this.phaseId
        );
        serverBus.$emit(
          "phase_setparametertank",
          this.tank_phase_vineId,
          this.phaseId
        );
      }
    },
    submit_parameter(e) {
      e.preventDefault();
      // serverBus.$emit("refresh_setparametertank", this.tank_phase_vineId);
      this.dialogNote = true;
    },
    closeModal() {
      serverBus.$off("refresh_setparametertank");
      serverBus.$off("phase_setparametertank");
      serverBus.$off("applied_setparametertank");

      this.getAllSifarnik();

      this.dialogNote = false;
    },
    customMounted2() {
      // alert(this.tankId);

      if (this.dialogNote2) {
        // alert(this.tank_phase_vineId);

        serverBus.$emit(
          "refresh_sugartemperaturetank",
          this.tank_phase_vineId,
          this.phaseMark
        );
        serverBus.$emit(
          "phase_sugartemperaturetank",
          this.tank_phase_vineId,
          this.phaseMark
        );
      }
    },
    customMounted3() {
      // alert(this.tankId);

      if (this.dialogNote3) {
        // alert(this.tank_phase_vineId);

        serverBus.$emit(
          "refresh_setcomment",
          this.tank_phase_vineId,
          this.phaseMark
        );
      }
    },
    customMounted4() {
      // alert(this.tankId);

      if (this.dialogNote4) {
        // alert(this.tank_phase_vineId);

        serverBus.$emit(
          "refresh_settankphase",
          this.tank_phase_vineId,
          this.tankId
        );
      }
    },
    customMounted5() {
      // alert(this.tankId);

      if (this.dialogNote5) {
        // alert(this.tank_phase_vineId);

        serverBus.$emit(
          "refresh_settankwine",
          this.tank_phase_vineId,
          this.tankId
        );
      }
    },
    submit_parameter2(e) {
      e.preventDefault();
      // serverBus.$emit("refresh_setparametertank", this.tank_phase_vineId);
      this.dialogNote2 = true;
    },
    closeModal2() {
      serverBus.$off("refresh_sugartemperaturetank");
      serverBus.$off("phase_sugartemperaturetank");
      serverBus.$off("applied_sugartemperaturetank");

      this.getAllSifarnik();

      this.dialogNote2 = false;
    },
    submit_parameter3(e) {
      e.preventDefault();
      // serverBus.$emit("refresh_setparametertank", this.tank_phase_vineId);
      this.dialogNote3 = true;
    },
    submit_parameter4(e) {
      e.preventDefault();
      // serverBus.$emit("refresh_setparametertank", this.tank_phase_vineId);
      this.dialogNote4 = true;
    },
    submit_parameter5(e) {
      e.preventDefault();
      // serverBus.$emit("refresh_setparametertank", this.tank_phase_vineId);
      this.dialogNote5 = true;
    },
    closeModal3() {
      serverBus.$off("refresh_setcomment");
      serverBus.$off("applied_setcomment");

      this.dialogNote3 = false;

      this.getAllSifarnik();
    },
    closeModal4() {
      serverBus.$off("refresh_settankwine");
      serverBus.$off("applied_settankwine");

      this.dialogNote4 = false;

      this.getAllSifarnik();
    },
    closeModal5() {
      serverBus.$off("refresh_settankwine");
      serverBus.$off("applied_settankwine");

      this.dialogNote5 = false;

      this.getAllSifarnik();
    },
    customMountedGrafic() {
      // alert(this.tankId);

      if (this.dialogNoteGrafic) {
        // alert(this.tank_phase_vineId);

        serverBus.$emit("refresh_grafik", this.tank_phase_vineId_grafik);
      }
    },
    submit_parameterGrafic(id) {
      //e.preventDefault();
      this.tank_phase_vineId_grafik = id;

      this.dialogNoteGrafic = true;
    },
    closeModalGrafic() {
      serverBus.$off("refresh_grafik");

      this.dialogNoteGrafic = false;
    },
    close_wine() {
      this.prikazi_vina = false;
    },
    nextPhases(idTank) {
      if (typeof idTank != "undefined")
        this.$http
          .get(
            this.globalServiceLocation +
              this.globalPort +
              "/tank_phase_wine/tank/" +
              idTank +
              "/phase_and_wine",
            {
              headers: {
                "Content-Type": "application/json",
                Authorization: "Bearer  " + localStorage.getItem("user-token"),
              },
            }
          )
          .then((response) => {
            // // // console.log(response.data);

            if (response.data.nextPhaseIds !== null) {
              if (response.data.nextPhaseIds.length > 0) {
                this.phase_to_items_pom = this.returnNextPhases(
                  response.data.nextPhaseIds,
                  response.data.phaseId
                );
                this.phaseId = response.data.phaseId;
              } else this.phase_to_items_pom = this.phase_to_items;
            } else this.phase_to_items_pom = this.phase_to_items;
          })
          .catch((e) => {
            if (!e.response) {
              alert(
                this.$t("error.message")
              );
            } else {
              if (e.response.status === 401) {
                this.$refs.frmtoken
                  .osvezavanjeTokena(localStorage.getItem("user-refresh-token"))
                  .then((result) => {
                    // // console.log(result);
                    // // console.log("Novi token - " + localStorage.getItem("user-token"));

                    this.$http
                      .get(
                        this.globalServiceLocation +
                          this.globalPort +
                          "/tank_phase_wine/tank/" +
                          idTank +
                          "/phase_and_wine",
                        {
                          headers: {
                            "Content-Type": "application/json",
                            Authorization:
                              "Bearer  " + localStorage.getItem("user-token"),
                          },
                        }
                      )
                      .then((response) => {
                        // // // console.log(response.data);

                        if (response.data.nextPhaseIds !== null) {
                          if (response.data.nextPhaseIds.length > 0) {
                            this.phase_to_items_pom = this.returnNextPhases(
                              response.data.nextPhaseIds,
                              response.data.phaseId
                            );
                            this.phaseId = response.data.phaseId;
                          } else this.phase_to_items_pom = this.phase_to_items;
                        } else this.phase_to_items_pom = this.phase_to_items;
                      })
                      .catch((e) => {
                        // // console.log(e.response);

                        let pomError = readJSON(e.response.data.message);
                        alert(pomError);
                      });
                  });
              } else {
                let pomError = readJSON(e.response.data.message);
                alert(pomError);
              }
            }
          });
    },
    returnNextPhases(locArray, id) {
      var i;
      var obj;
      var pomArray = [];

      obj = this.phase_to_items.findIndex((x) => x.id === id);

      // 					// // console.log(obj);

      // 						if (typeof obj !== "undefined")
      // 							if (obj > -1)
      // 							 pomArray.push(this.phase_to_items[obj])

      if (typeof obj !== "undefined")
        if (obj > -1)
          for (i = 0; i < locArray.length; i++) {
            obj = this.phase_to_items.findIndex((x) => x.id === locArray[i]);

            if (typeof obj !== "undefined")
              pomArray.push(this.phase_to_items[obj]);
          }

      return pomArray;
    },
    getAllFaze() {
      this.$http
        .get(this.globalServiceLocation + this.globalPort + "/phase/all", {
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer  " + localStorage.getItem("user-token"),
          },
        })
        .then((response) => {
          //// // console.log(response.data);
          this.phase_to_items = response.data;
          this.phase_to_items.splice(0, 0, { id: undefined, name: undefined });
        })
        .catch((e) => {
          if (!e.response) {
            alert(
              this.$t("error.message")
            );
          } else {
            if (e.response.status === 401) {
              this.$refs.frmtoken
                .osvezavanjeTokena(localStorage.getItem("user-refresh-token"))
                .then((result) => {
                  // // console.log(result);
                  // // console.log("Novi token - " + localStorage.getItem("user-token"));

                  this.$http
                    .get(
                      this.globalServiceLocation +
                        this.globalPort +
                        "/phase/all",
                      {
                        headers: {
                          "Content-Type": "application/json",
                          Authorization:
                            "Bearer  " + localStorage.getItem("user-token"),
                        },
                      }
                    )
                    .then((response) => {
                      //// // console.log(response.data);
                      this.phase_to_items = response.data;
                      this.phase_to_items.splice(0, 0, {
                        id: undefined,
                        name: undefined,
                      });
                    })
                    .catch((e) => {
                      // // console.log(e.response);

                      let pomError = readJSON(e.response.data.message);
                      alert(pomError);
                    });
                });
            } else {
              let pomError = readJSON(e.response.data.message);
              alert(pomError);
            }
          }
        });
    },
    ucitavanjePodataka() {
      this.cena = "";

      this.tank_phase_vineId = this.$route.params.id;
      this.tankId = this.$route.params.idTank;

      if (typeof this.$route.params.active !== "undefined")
        if (this.$route.params.active) this.dozvoljena_izmena = 1;
        else this.dozvoljena_izmena = 0;
      else this.dozvoljena_izmena = 1;

      this.getAllSifarnik();

      if (this.tankId !== undefined) this.getAllSifarnikBarika();

      this.getAllFaze();
      this.nextPhases(this.tankId);

      this.getAllVina();

      this.administrator = this.daLiJeAdmin();
      
    },
  },
  watch: {
    $route() {
      this.ucitavanjePodataka();
      this.getGrapeVarietyParts();
    },
  },
  beforeMount() {
    serverBus.$off("ucitaj_podatke");
    this.ucitavanjePodataka();

    serverBus.$on("ucitaj_podatke", () => {
      if(this.administrator){
        this.cena = "";
        this.cenaKostanja();
      }

      if (this.tankId !== undefined) this.getAllSifarnikBarika();

      if (this.dozvoljena_izmena && this.tankId !== undefined)
        this.idiNaPrazanTank(this.tank_phase_vineId, this.tankId);
    });
  },

  beforeDestroy() {
    if (this.chart) {
      this.chart.dispose();
    }
  },
  mounted() {
    // we will create the chart here
    this.getGrapeVarietyParts();
    
  },
};
</script>

<style scoped lang='scss'>
@import "../assets/sass/viewStyles/EmptySingleTank";
@import "./../assets/sass/parts/modalStyles";
@import "../assets/sass/parts/_tanksRoom.scss";

.closeModalInModalBtn {
  position: absolute;
  right: 0;
  top: 0;
}

.hello {
  width: 100%;
  height: 300px;
}

.columnLeft {
  float: left;
}

.columnRight {
  float: right;
  color: #8e302f;
  font-weight: bold;
}

/* Clear floats after the columns */
// .row:after {
//   content: "";
//   display: table;
//   clear: both;
// }

.TabClass {
  h2 {
    display: flex;
    font-size: 16px;
    font-weight: 400;
    margin-bottom: 15px;
    // text-transform: uppercase;
    border-bottom: 2px solid #930022;
    padding-top: 10px;
  }
}

// .v-tooltip__content {
//   font-size: 14px !important;
//   color: black;
//   opacity: 1 !important;
//   background-color: white !important;
//   font-family: Roboto, sans-serif;
// }

.custom-highlight-row {
  background-color: #f3f7f4;
}

.green-bg {
  /* Set the display to `table-row` because Vuetify makes `flex` */
  display: table-row;
}

.green-bg:before {
  /* `!important` is necessary here because Vuetify overrides this */
  background: green !important;
}
.green-bg:hover {
  /* `!important` is necessary here because Vuetify overrides this */
  background: green !important;
}
</style>
